import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleListActions,
  setGeoLoactionStateAction,
  setRegionActions,
  setZoneActions,
  SetTheSetUserSignError,
  SetSignaturePops,
  SetTheCountNumbersNam,
  SetChangedUrl,
  setUserActions, ///---userList get ----
  setUserOptionDatasActions,
  setTheSingatureFilename,
  setAdminuseraccesslistDatasgetlistActions, ///---admin---get--list
  setTheAttendanceLocationAction, ///pan---india access
  setThepresentUrlOfSignature,
  setThePresentUrlsSended,
  settheFullPresentUrl,
  setClientBranchActions,
  setTablePositionPersist,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/User/UserCreateForm.scss";
import MultiSelect from "multiselect-react-dropdown"; // Import MultiSelect component
import Select from "react-select";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import validator from "validator";
import { Navigate, useNavigate } from "react-router-dom";
import {
  setUserCreateActions,
  SetUserREtrieveActions,
  SetUserEditActions,
} from "../../../Redux/Slice";
import { el, tr } from "date-fns/locale";
import SignaturePopup from "../User/SignaturePopup";
import useDebouncedEffect from "use-debounced-effect";
import Swal from "sweetalert2";

const UserCreateForm = (props) => {
  const {
    currentPage,
    setShow,
    show,
    EditId,
    UserEditPopup,
    setUserEditPopup,
    white_collar,
    search,
    datafilter,
    reporintrenders,
    role_filter,
  } = props;
  var AuthorizedId;
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const [role, setRole] = useState([]);
  const state = useSelector((state) => state);
  const [FirstError, setFirstError] = useState("");
  const [lastError, setLastError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [userError, setUserError] = useState("");
  const [phonenmErr, setphoneeer] = useState("");
  let [nameList, setOptions] = useState([]);
  // const [search, setSearch] = useState("");
  const [RegionError, setRegionError] = useState("");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const Swal = require("sweetalert2");

  const [ErrorInde, setErrInde] = useState(0);
  // console.log(datafilter   , "datafilter" ,search ,state.ClientBranchIDs.UserDatas);
  ///User-----------------------_List
  const [multiselectUser, setMuliuserselect] = useState([]);
  const [UserErr, setUserErr] = useState("");
  const [OptionsUser, setOptionsUser] = useState();

  ///--User---list
  const [ManagerSign, SetManagerSign] = useState(false);
  const [UserSignError, setUserSignError] = useState("");
  const [Img, setImg] = useState(null);
  let state_id_edit = [];
  let RegionEDITS = [];
  let EditListZone = [];
  let objectState = [];
  let State_idObject = [];
  let Region_IDS = [];
  let User_Edit_role = [];
  const Navigate = useNavigate();
  const createnewuser = {
    first_name: "",
    last_name: "",
    email: "",
    user_role: "",
    user_name: "",
    password: "",
    state_id: [],
    region_id: [],
    zone_id: [],
    // total_permissions: "",
    personal_leave: 1,
    casual_leave: 1,
    // leave_valid_until: "",
    // permission_valid_until: "",
    sub_role: null,
    admin_access: "",
    phone_number: "",
    super_admin: false,

    authorized_person: "",
    attendance_locations: [],
    pan_india: false,
    user_uid: "",
    unregister_access: false,
    branch_ids: [],
    is_active: true,
  };
  const form_data = new FormData();
  const EditFormData = new FormData();
  const [AuthorizedErr, setAthoorizedErr] = useState();
  const [AuthorizedPer, setAthorized] = useState();
  const [totalLeaveprErr, setToleavePre] = useState();
  const [shifttimeErro, setShiftError] = useState();
  const [personalLevaeErr, setPersonslErr] = useState("");
  const [casualErro, setCasualErr] = useState("");
  const [permissionLeErr, setPermissionErr] = useState("");
  const [LeaveValiErr, setLeaveErr] = useState("");
  const [organizationSelectedList, setOrganizationSelectedList] = useState([]);

  const [viewpass, setViewpass] = useState(false);
  const [data, setData] = useState(createnewuser);
  console.log(data, "datasdasa");
  const [multidselectwwe, setMuliselect] = useState([]);
  const [roleError, setroleError] = useState();
  const [Selected, setSelected] = useState([]);
  const [CountingNum, setCountingNum] = useState(1);
  const Signature = {
    signature: "",
  };
  const [Signs, setSign] = useState(Signature);

  ////-----------State----Region---Zone
  const [State, setState] = useState([]);
  const [multiselectState, setMuliStateselect] = useState([]);
  const [NameListState, setNameList] = useState([]);
  const [stateerror, setStateError] = useState("");
  const [REgion, setRegionSelected] = useState([]);
  const [REgionslist, setRegion] = useState([]);
  const [Zone, setZone] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [ZoneError, setZoneError] = useState("");
  const [nameList4, setOptions4] = useState([]);
  ///----Edits-------State -----region----zone---Chnage
  const [stateMul, setStateMul] = useState([]);
  const [SelectedStates, SetStates] = useState([]);
  const [regionSelected, setRegionMUl] = useState([]);
  const [ZoneMulEdi, setZoneMulEdi] = useState([]);
  const [SelectedZone, setZoneSelected] = useState([]);
  const [SelectRegion, setSlectRegions] = useState([]);
  const RoleSearched = {
    RoleSearch: "",
    UserName: "",
  };
  const [SearchedValRole, setSearchedRole] = useState(RoleSearched);
  const [Organization_options, setOrganizations_options] = useState([]);

  const [selectcheckeded, setSelectchecked] = useState([]);
  const [optionsForAdim, setOPtionAdmin] = useState([]);
  const [selectadminaccesEdi, setAdimAccessEdi] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsEdit, setSelectedOptionsEdit] = useState([]);

  const [SuperAdminOptions, setSuperAdminOptions] = useState(false);
  const [woriingstatus, setworkingsttae] = useState({
    total_permissions: "",
    personal_leave: "",
    casual_leave: "",
    leave_valid_until: "",
    permission_valid_until: "",
  });

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Attendancelocation_se: "",
    Branch_code_se: "",
  };

  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    RoleSearch: "",
    UserName: "",
    Attendancelocation_se: "",
    Branch_code_se: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [superTrue, setsupertrue] = useState(false);
  const [PanIndia, setPanIndia] = useState(false);
  const [Branch_code_options, setBranch_code_options] = useState([]);
  const [Branch_codeVal, setBranch_codeVal] = useState([]);
  const [site_code_err, set_siteCode_err] = useState("");

  ///--------User---sub---role--------
  //---options
  const Options = [
    // {
    //   value: "0",
    //   label: "PAYROLL",
    // },
    {
      value: "1",
      label: "REGIONAL MANAGER",
    },
    {
      value: "2",
      label: "ONBOARDER",
    },
    {
      value: "3",
      label: "SUPER ADMIN",
    },
    // {
    //   value: "4",
    //   label: "SUPERVISOR",
    // },

    {
      value: "5",
      label: "SKILL ASSESSMENT",
    },
  ];

  const [SubRollError, setSubRollError] = useState();
  const [subrollSelect, setsubrolselect] = useState();
  const [fieldaccess, setfieldacces] = useState(0);
  const [PanIndiaPlace, setPanIndiaPlace] = useState([]);
  const [PanIndiaPlaceVal, setPanIndiaPlaceVal] = useState([]);
  ///----sub---rol---changes----

  let currentDate = new Date();
  let year = currentDate.getFullYear();

  // Calculate the end of the current year
  let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // Format the current date and end of year
  let currentMonth =
    (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  let currentDay =
    (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  let endOfYearMonth =
    (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  let endOfYearDay =
    (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  let formattedEndOfYear = `${year}-12-31`;

  useEffect(() => {
    const payload = {
      search: "",
      page_size: "",
      page: 1,
    };
    dispatch(setAdminuseraccesslistDatasgetlistActions(payload));
  }, []);

  useEffect(() => {
    const payload = {
      search: SearchedVal.Attendancelocation_se,
      page_size: 20,
      page: 1,
    };
    dispatch(setTheAttendanceLocationAction(payload));
  }, [SearchedVal.Attendancelocation_se]);

  const inputRef = useRef(null);

  const preventZoom = (event) => {
    console.log(event._reactName, "Sdasd event", event, event.nativeEvent);

    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      ((event.ctrlKey || event.metaKey) &&
        (event.key === "+" || event.key === "-" || event.type === "wheel")) ||
      (event._reactName == "onWheel" && event._reactName != "onKeyDown")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys: 'e', '+', '-', '.', Arrow keys, and prevent zooming with the mouse wheel
    if (
      ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(event.key) ||
      event.type === "wheel" ||
      (event._reactName == "onWheel" && event._reactName != "onKeyDown")
    ) {
      event.preventDefault();
    }
  };

  const Handletoggle = () => {
    setData((prev) => ({
      ...prev,
      unregister_access: !prev.unregister_access,
    }));
  };

  const handlePaste = (event) => {
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const filtered = paste.replace(/[^0-9]/g, ""); // Strip non-numeric characters
    event.preventDefault();
    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } });
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const adminUserList = [];

  ///----Access000List-----
  useEffect(() => {
    if (state.AdminuseraccesslistCall.AdminuseraccesslistDatas != undefined) {
      const objectAmdinList = [];
      const key_names = [];

      state.AdminuseraccesslistCall.AdminuseraccesslistDatas.forEach(
        (element) => {
          console.log(element, "element", element.display_name);
          objectAmdinList.push({
            // id: element.id,
            value: element.unique_name,
            name: `${element.unique_name.toUpperCase()} ${element.display_name ? `- ${element.display_name.toUpperCase()}` : ""}`,
          });
          key_names.push(element?.unique_name);
        },
      );
      console.log(key_names, "key_names");

      setOPtionAdmin(objectAmdinList);
    }
  }, [state.AdminuseraccesslistCall.AdminuseraccesslistDatas]);
  console.log(
    state.AdminuseraccesslistCall.AdminuseraccesslistDatas,
    "state.AdminuseraccesslistCall.AdminuseraccesslistDatas",
  );

  /////-----
  useEffect(() => {
    dispatch(setThePresentUrlsSended(false));
  }, []);

  useEffect(() => {
    if (state.AttendanceLocationSliceCall.AttendanceLocationData != undefined) {
      const objectAmdinList = [];

      state.AttendanceLocationSliceCall.AttendanceLocationData.forEach(
        (element) => {
          objectAmdinList.push({
            value: element.id,
            label: element.place_name.toUpperCase(),
          });
        },
      );
      setPanIndiaPlace(objectAmdinList);
    }
  }, [
    state.AttendanceLocationSliceCall.AttendanceLocationData,
    SearchDebounance.Attendancelocation_se,
  ]);

  //  console.log(PanIndiaPlace , "PanIndiaPlace");
  console.log(optionsForAdim, "optionsForAdim", selectedOptions);

  const handleChange = (selectedList, _) => {
    console.log(selectedList, "selectedList selectedList");

    setSelectedOptions(selectedList);
    const access = [];
    selectedList != undefined &&
      selectedList.map((item) => {
        access.push(item.value);
      });
    setData({
      ...data,
      admin_access: access,
    });
  };

  const handleSubRollSelect = (e) => {
    setData({
      ...data,
      sub_role: e.value,
    });

    if (e.value == 1) {
      SetManagerSign(true);
    } else if (e.value != 1) {
      SetManagerSign(false);
    }

    // if (e.value == "2") {
    //   setSuperAdminOptions(false);
    //   setfieldacces(1);
    //   setData({
    //     ...data,
    //     admin_access: [],
    //     sub_role: e.value,
    //   });
    // } else if (e.value != "2") {
    //   setfieldacces(0);
    //   setSuperAdminOptions(false);
    // }
    if (e.value == "3") {
      setSuperAdminOptions(true);
      setPanIndiaPlaceVal(null);
      setData({
        ...data,
        sub_role: e.value,
        pan_india: true,
        attendance_locations: [],
      });
    } else if (e.value != "3") {
      setSuperAdminOptions(false);
      setData({
        ...data,
        sub_role: e.value,
        pan_india: false,
      });
    }
    // console.log(e.value, "subrolsdfsd");
  };
  /// Branch _code
  const Handlethe_site_code = (selectedVal) => {
    if (selectedVal != null) {
      setBranch_codeVal(selectedVal);
      let Valu_codes = [];
      selectedVal.map((item) => {
        Valu_codes.push(item?.value);
      });

      setData({
        ...data,
        branch_ids: Valu_codes,
      });
    } else {
      setBranch_codeVal([]);
      setData({
        ...data,
        branch_ids: [],
      });
    }
  };

  ///-----State----Input Changes
  const handleInputChangeRole = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      RoleSearch: Val,
    });
  };

  const handleInputChangeCreateuser = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      UserName: Val,
    });
  };

  //---Usr------Authorized---persons----changes---------
  const handleSelectuserChange = (e) => {
    if (e != null) {
      setAthorized(e);
      setMuliuserselect(e);
      setData({
        ...data,
        authorized_person: e.value,
      });
    }
    if (e == null) {
      setData({
        ...data,
        authorized_person: "",
      });
      setMuliuserselect([]);
      setAthorized("");
    }
  };

  /////---User---
  useEffect(() => {
    const payload = {
      search: SearchedValRole.UserName,
      page_size: 20,
      page: 1,
      white_collar: true,
    };
    // dispatch(setUserActions(payload));
    dispatch(setUserOptionDatasActions(payload));
  }, [SearchedValRole.UserName]);
  useEffect(() => {
    if (state.UserSelectedPayloadsSlice.UserOptionsDataList != "") {
      let objectArray = [];
      state.UserSelectedPayloadsSlice.UserOptionsDataList.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.first_name.toUpperCase(),
        });
      });
      // console.log(objectArray ,"objectArray");
      setOptionsUser(objectArray);
    }
  }, [
    state.UserSelectedPayloadsSlice.UserOptionsDataList,
    SearchedValRole.UserName,
  ]);

  useEffect(() => {
    if (EditId != undefined) {
      const payload = {
        EditId: EditId,
      };
      dispatch(SetUserREtrieveActions(payload));
    }
  }, []);
  useEffect(() => {
    const payloads = {
      search: SearchedValRole.RoleSearch,
      page_size: 10,
      page: 1,
      mode: "all",
      client: "",
      white_collar: true,
    };
    dispatch(getRoleListActions(payloads));
  }, [SearchedValRole.RoleSearch]);
  // console.log(ManagerSign , "ManagerSign");
  const handleSubRollEDITSelect = (e) => {
    console.log(e, "Sdfsdfsdfwdf");
    if (e.value == 1) {
      SetManagerSign(true);
    } else if (e.value != 1) {
      SetManagerSign(false);
    }

    setsubrolselect(e);
    setData({
      ...data,
      sub_role: e.value,
    });
    if (e.value == 3) {
      setSuperAdminOptions(true);

      setData({
        ...data,
        super_admin: true,
        sub_role: e.value,
      });
    }

    if (e.value == 1) {
      SetManagerSign(true);
    } else if (e.value != 1) {
      SetManagerSign(false);
    }

    // if (e.value == 2) {
    //   setfieldacces(1);
    //   setData({
    //     ...data,
    //     admin_access: [],
    //     sub_role: e.value,
    //   });
    //   setSuperAdminOptions(false);
    // } else if (e.value != 2) {
    //   setfieldacces(0);
    // }

    if (e.value == "3") {
      setSuperAdminOptions(true);
    } else if (e.value != "3") {
      setSuperAdminOptions(false);
    }
  };
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          Attendancelocation_se: SearchDebounance.Attendancelocation_se,
          Branch_code_se: SearchDebounance?.Branch_code_se,
        });
        setSearchedRole({
          ...SearchedValRole,
          UserName: SearchDebounance.UserName,
          RoleSearch: SearchDebounance.RoleSearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    console.log(Val, "Values");
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };
  //---Zone----
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  ///----Regions----
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  console.log(state.UserRetrieve.userRetrireve, "userRetrireve");

  useEffect(() => {
    if (
      EditId != undefined &&
      state.UserRetrieve != undefined &&
      state.UserRetrieve.userRetrireve.id == EditId &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.state_id != undefined &&
      // state.UserRetrieve.userRetrireve.state_id[0].id != undefined &&
      //
      // state.UserRetrieve.userRetrireve.state_id[0] != undefined &&
      // state.UserRetrieve.userRetrireve.region_id[0] != undefined &&
      state.UserRetrieve.userRetrireve.region_id != null &&
      state.UserRetrieve.userRetrireve.region_id != []
    ) {
      let AttendanceIDs = [];
      if (
        state.UserRetrieve.userRetrireve.attendance_locations != null &&
        state.UserRetrieve.userRetrireve.attendance_locations != undefined
      ) {
        const objectAmdinList = [];

        state.UserRetrieve.userRetrireve.attendance_locations.forEach(
          (element) => {
            objectAmdinList.push({
              value: element.id,
              label: element.place_name.toUpperCase(),
            });
            AttendanceIDs.push(element.id);
          },
        );
        setPanIndiaPlaceVal(objectAmdinList);
      }
      let regionID = [];
      state.UserRetrieve.userRetrireve.region_id.map((item) => {
        regionID.push(item.id);
      });
      let ZoneID = [];
      state.UserRetrieve.userRetrireve.zone_id.map((item) => {
        ZoneID.push(item.id);
      });

      let Branch_codes_Val = [];
      state.UserRetrieve.userRetrireve.branch_ids.map((item) => {
        Branch_codes_Val.push(item.id);
      });

      setData({
        ...data,
        first_name: state.UserRetrieve.userRetrireve.first_name,
        last_name: state.UserRetrieve.userRetrireve.last_name,
        email: state.UserRetrieve.userRetrireve.email,
        user_role: state.UserRetrieve.userRetrireve.user_role.id,
        user_name: state.UserRetrieve.userRetrireve.user_name,
        // state_id: state.UserRetrieve.userRetriroffeve.state_id.id,
        // region_id: state.UserRetrieve.userRetrireve.region_id.id,
        //zone_id: state.UserRetrieve.userRetrireve.zone_id.id,
        state_id: State_idObject,
        // region_id: Region_IDS ,
        //state_id:state_id_edit,
        zone_id: ZoneID,
        region_id: regionID,
        sub_role: state.UserRetrieve.userRetrireve?.sub_role,
        // leave_valid_until: woriingstatus.leave_valid_until,
        casual_leave: woriingstatus.casual_leave,
        // permission_valid_until: woriingstatus.permission_valid_until,
        personal_leave: woriingstatus.personal_leave,
        admin_access: selectadminaccesEdi,
        phone_number:
          state.UserRetrieve.userRetrireve.phone_number != null
            ? state.UserRetrieve.userRetrireve.phone_number
            : "",
        super_admin:
          state.UserRetrieve.userRetrireve.super_admin != null
            ? state.UserRetrieve.userRetrireve.super_admin
            : false,
        authorized_person:
          state.UserRetrieve.userRetrireve.authorized_person != undefined &&
          state.UserRetrieve.userRetrireve.authorized_person != null &&
          state.UserRetrieve.userRetrireve.authorized_person.first_name !=
            undefined &&
          state.UserRetrieve.userRetrireve.authorized_person.id != undefined &&
          state.UserRetrieve.userRetrireve.authorized_person.first_name !=
            null &&
          state.UserRetrieve.userRetrireve.authorized_person.id != null
            ? state.UserRetrieve.userRetrireve.authorized_person.id
            : "",
        pan_india:
          state.UserRetrieve.userRetrireve.pan_india != null
            ? state.UserRetrieve.userRetrireve.pan_india
            : false,
        attendance_locations: AttendanceIDs,
        user_uid: state.UserRetrieve.userRetrireve.user_uid,
        unregister_access: state.UserRetrieve.userRetrireve.unregister_access,
        branch_ids: Branch_codes_Val,
        is_active:
          state.UserRetrieve.userRetrireve?.is_active == null
            ? false
            : state.UserRetrieve.userRetrireve?.is_active,
      });
      //  if(state.UserRetrieve.userRetrireve.pan_india != null ) {
      // setPanIndia(state.UserRetrieve.userRetrireve.pan_india)
      //  }

      User_Edit_role.push(state.UserRetrieve.userRetrireve.user_role.role);
      if (state.UserRetrieve.userRetrireve.branch_ids != null) {
        const Branch_codesSelected = [];
        state.UserRetrieve.userRetrireve.branch_ids.map((item) => {
          Branch_codesSelected.push({
            label: item.branch_code,
            value: item.id,
          });
        });
        setBranch_codeVal(Branch_codesSelected);
      }

      if (state.UserRetrieve.userRetrireve.branch_ids == null) {
        setBranch_codeVal([]);
      }
      // console.log(data, "kzxnc,xm", User_Edit_role);

      if (state.UserRetrieve.userRetrireve.sub_role != null) {
        console.log(
          Options,
          "Options324234 234",
          state.UserRetrieve.userRetrireve.sub_role,
          data.sub_role,
        );

        //---sub---rolw-----
        Options.forEach((element) => {
          if (state.UserRetrieve.userRetrireve?.sub_role == element.value) {
            console.log(element.value, element, "asbdas");
            setsubrolselect(element);
            if (element.value == 2) {
              // setfieldacces(1);
              setfieldacces(0);
            }
          }

          if (state.UserRetrieve.userRetrireve?.sub_role == "3") {
            setSuperAdminOptions(true);
          }

          if (state.UserRetrieve.userRetrireve?.sub_role != "3") {
            setSuperAdminOptions(false);
          }

          if (state.UserRetrieve.userRetrireve?.sub_role == 1) {
            SetManagerSign(true);
          } else if (data.sub_role != 1) {
            SetManagerSign(false);
          }
        });
      }
      if (state.UserRetrieve.userRetrireve.sub_role == null) {
        setsubrolselect([]);
      }
      ////---admin---acces---
      if (
        state.UserRetrieve.userRetrireve != undefined &&
        state.UserRetrieve.userRetrireve.admin_access != "" &&
        state.UserRetrieve.userRetrireve.admin_access != null &&
        state.UserRetrieve.userRetrireve.admin_access != undefined
      ) {
        setAdimAccessEdi(state.UserRetrieve.userRetrireve.admin_access);
        let optionsEdit = [];
        state.UserRetrieve.userRetrireve.admin_access.map((item, index) => {
          console.log(item, "sdoqeiwd", index);
          optionsEdit.push({
            // id: index,
            // name: item,
            value: item,
            name: item.toUpperCase(),
          });
        });
        setSelectedOptions(optionsEdit);
        setSelectedOptionsEdit(optionsEdit);
      }

      ///--Authorized--person
      if (
        state.UserRetrieve.userRetrireve != undefined &&
        state.UserRetrieve.userRetrireve.authorized_person != undefined &&
        state.UserRetrieve.userRetrireve.authorized_person != null &&
        state.UserRetrieve.userRetrireve.authorized_person.first_name !=
          undefined &&
        state.UserRetrieve.userRetrireve.authorized_person.id != undefined &&
        state.UserRetrieve.userRetrireve.authorized_person.first_name != null &&
        state.UserRetrieve.userRetrireve.authorized_person.id != null
      ) {
        let selectedObjects = [];
        AuthorizedId = state.UserRetrieve.userRetrireve.authorized_person.id;

        console.log(
          state.UserRetrieve.userRetrireve.authorized_person.id,
          state.UserRetrieve.userRetrireve.authorized_person.first_name,
          "asdasdasdqw",
        );
        selectedObjects.push({
          value: state.UserRetrieve.userRetrireve.authorized_person.id,
          label: state.UserRetrieve.userRetrireve.authorized_person.first_name,
        });
        setAthorized(selectedObjects);
        console.log(AuthorizedId, "AuthorizedId");
      }

      if (
        state.UserRetrieve.userRetrireve.user_sign_image != undefined &&
        state.UserRetrieve.userRetrireve.user_sign_image != null &&
        state.UserRetrieve.userRetrireve.user_sign_image.media_url != undefined
      ) {
        setImg(state.UserRetrieve.userRetrireve.user_sign_image.media_url);
        dispatch(
          setThepresentUrlOfSignature(
            state.UserRetrieve.userRetrireve.user_sign_image.media_url,
          ),
        );
        setSign({
          ...Signs,
          signature: state.UserRetrieve.userRetrireve.user_sign_image.media_url,
        });
      }

      if (
        state.UserRetrieve.userRetrireve.user_sign_image == undefined ||
        state.UserRetrieve.userRetrireve.user_sign_image == null ||
        state.UserRetrieve.userRetrireve.user_sign_image.media_url == undefined
      ) {
        dispatch(setThepresentUrlOfSignature(""));
      }
    }
  }, [
    state.UserRetrieve.userRetrireve.id,
    // SelectRegion,
    // SelectedZone,
    // SelectedStates,

    // state.UserRetrieve.userRetrireve.region_id,

    // state.UserRetrieve.userRetrireve.state_id,
  ]);

  ///--For---Working---status----------
  useEffect(() => {
    if (
      state.UserRetrieve.userRetrireve != undefined &&
      state.UserRetrieve.userRetrireve != null &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.working_status != null &&
      state.UserRetrieve.userRetrireve.working_status != undefined
    ) {
      // console.log(
      //   state.UserRetrieve.userRetrireve.working_status,
      //   "worling statue"
      // );
      setworkingsttae({
        ...woriingstatus,
        total_permissions:
          state.UserRetrieve.userRetrireve.working_status.total_permissions,
        casual_leave:
          state.UserRetrieve.userRetrireve.working_status.casual_leave,
        personal_leave:
          state.UserRetrieve.userRetrireve.working_status.personal_leave,
        permission_valid_until:
          state.UserRetrieve.userRetrireve.working_status
            .permission_valid_until,
        leave_valid_until:
          state.UserRetrieve.userRetrireve.working_status.leave_valid_until,
      });
    }
  }, [state.UserRetrieve.userRetrireve.id]);

  useEffect(() => {
    if (
      EditId != undefined &&
      EditId != " " &&
      state.UserRetrieve.userRetrireve != undefined &&
      state.UserRetrieve.userRetrireve != null &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.user_role != undefined &&
      state.UserRetrieve.userRetrireve.user_role != null &&
      state.UserRetrieve.userRetrireve.user_role.id != undefined &&
      state.UserRetrieve.userRetrireve.user_role.id != null
    ) {
      let objectedit = [];
      console.log(state.UserRetrieve.userRetrireve, "statuss");
      objectedit.push({
        value: state.UserRetrieve.userRetrireve.user_role.id,
        label: state.UserRetrieve.userRetrireve.user_role.role,
      });
      setSelected(objectedit);
      // console.log(Selected, "Seleted", nameList);
    }
  }, [state.UserRetrieve.userRetrireve.id]);

  // const handleClose = () => {
  //   if (EditId != "" && EditId != undefined) {
  //     setShow(false);
  //   } else if (EditId == undefined) {
  //     Navigate("/user");
  //   }
  // };
  const handleClose = () => {
    // Compare the current data with the default (createnewuser)
    const hasFormChanges = Object.keys(createnewuser).some((key) => {
      const currentValue = data[key];
      const initialValue = createnewuser[key];

      // Handle arrays
      if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
        return (
          currentValue.length !== initialValue.length ||
          currentValue.some((val, idx) => val !== initialValue[idx])
        );
      }

      // Handle objects
      if (
        typeof currentValue === "object" &&
        currentValue !== null &&
        typeof initialValue === "object" &&
        initialValue !== null
      ) {
        return JSON.stringify(currentValue) !== JSON.stringify(initialValue);
      }

      // Handle primitives (string, number, boolean)
      return currentValue !== initialValue;
    });

    // 🔹 For Edit mode → always show alert
    // 🔹 For Create mode → only show alert if form data changed
    const shouldShowAlert =
      EditId != "" && EditId != undefined ? true : hasFormChanges;

    if (shouldShowAlert) {
      Swal.fire({
        title: `Do you want to exit?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          if (EditId != "" && EditId != undefined) {
            setShow(false); // Close popup in Edit mode
          } else if (EditId === undefined) {
            Navigate("/user"); // Go to user list page in Create mode
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    } else {
      // No data changes → directly close or navigate
      if (EditId != "" && EditId != undefined) {
        setShow(false);
      } else if (EditId === undefined) {
        Navigate("/user");
      }
    }
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-zA-Z]).{8,}$/;

  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    return passwordRegex.test(password);
  };
  console.log(optionsForAdim, "optionsForAdim woeuoqwei", selectedOptions);

  const HandleChangesAdminRights = (e, valuess) => {
    console.log(
      valuess,
      "siuoAIS ADMIN Access ",
      optionsForAdim,
      selectedOptions,
      selectedOptionsEdit,
    );

    if (e.target.name === "super_admin") {
      if (valuess == true) {
        const allAccess = optionsForAdim.map((item) => item.value);

        setData({
          ...data,
          admin_access: allAccess,
          super_admin: true,
          authorized_person: null,
        });

        setSelectedOptions(optionsForAdim);
        setSelectchecked(optionsForAdim);
      } else {
        setData({
          ...data,
          admin_access: [],
          super_admin: false,
        });
        setSelectedOptions([]); // reset selected items only
        setSelectchecked([]); // do NOT touch options
      }
    }
  };

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];

      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);

  const capitalizeFirstLetter = (value) => {
    if (typeof value !== "string") return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  };
  const HandleChanges = (e, valuess) => {
    if (e.target.name == "personal_leave") {
      const { name, value } = e.target;

      // setData({
      //   ...data,
      //   [name]: Number(value),
      // });
      setData({
        ...data,
        [name]: value,
      });
    } else if (e.target.name == "casual_leave") {
      const { name, value } = e.target;

      // setData({
      //   ...data,
      //   [name]: Number(value),
      // });
      setData({
        ...data,
        [name]: value,
      });
    } else if (e.target.name == "total_permissions") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: Number(value),
      });
    } else if (e.target.name == "phone_number") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });
    } else if (e.target.name == "super_admin") {
      // const { name, value } = e.target;

      // setData({
      //   ...data,
      //   [name]: valuess,
      // });
      console.log(valuess, "valuess");

      if (valuess == true) {
        // console.log(valuess, "valuess", optionsForAdim);
        var admin_accessdatas = [];

        optionsForAdim.forEach((element) => {
          console.log(element.id, "Sdfsd");
          // admin_accessdatas.push(element.name);
          admin_accessdatas.push(element.value);
        });

        setData({
          ...data,
          admin_access: admin_accessdatas,
          super_admin: valuess,
          authorized_person: null,
        });

        setSelectedOptions(optionsForAdim);
      } else if (valuess == false) {
        setData({
          ...data,
          admin_access: [],
          super_admin: valuess,
        });
        setSelectedOptions([]);
      }
    } else if (e.target.name == "email") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });

      const isValidEmail = validateEmail(value);
      // console.log(isValidEmail, "87e0qweihw");

      if (!isValidEmail) {
        if (value != "") {
          setEmailError("*Enter Valid Email ID");

          setErrInde(1);
        }
      } else {
        setErrInde(0);
        setEmailError("");
      }
    } else if (e.target.name == "password") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });

      // console.log(validatePassword(value), "aslkhdoihe8uw", PasswordError);
      const isValidPassword = validatePassword(value);

      if (isValidPassword) {
        setErrInde(0);
        setPasswordError("");
      } else {
        setErrInde(1);
        setPasswordError(
          "*Password must be at least 8 characters long and include an uppercase letter, lowercase letter, digit, and special character.",
        );
      }
    } else if (e.target.name == "pan_india") {
      console.log(valuess, "valuess");

      if (valuess == true || data.sub_role == 3) {
        setData({
          ...data,

          pan_india: valuess,
          attendance_locations: [],
        });

        setPanIndiaPlaceVal(null);
      } else if (valuess == false) {
        setData({
          ...data,
          pan_india: valuess,
          attendance_locations: [],
        });
      }
    } else if (e.target.name == "first_name" || e.target.name == "last_name") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: capitalizeFirstLetter(value),
      });
    } else {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });
    }

    // setData((prev) => {
    //   return {
    //     ...prev,
    //     [e.target.name]: e.target.value,
    //   };
    // });
  };

  // console.log(data, "23870jidsknx");

  const [searchRole, setSearchRole] = useState("");
  const handleSelectChange = (selectedVal) => {
    setMuliselect(selectedVal);
    setData({
      ...data,
      user_role: selectedVal.value,
    });
  };

  useEffect(() => {
    if (state.rolelists.RoleList.id != undefined) {
      setRole(state.rolelists.RoleList.role);
    }
  }, [state.rolelists.RoleList]);

  useEffect(() => {
    const Datas = [];

    setRole(state.rolelists.RoleList.role);
    if (state.rolelists.RoleList != undefined) {
      let objectArray = [];
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({ value: element.id, label: element.role });
      });
      // console.log(state.rolelists.RoleList, "roless");

      setOptions(objectArray);
    }
  }, [state.rolelists]);

  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "20",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);

  useEffect(() => {
    const payloads = {
      search: SearchedVal.Branch_code_se,
      page_size: "20",
      page: 1,
    };
    // state.ClientBranch.ClientBranchess
    dispatch(setClientBranchActions(payloads));
  }, [SearchedVal.Branch_code_se]);

  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
        if (element.branch_code != "" && element.branch_code != null) {
          objectArray.push({
            value: element.id,
            label: `${element.branch_code} ${element?.client_name ? `- ${element?.client_name}` : ""}`,
          });
        }
      });

      setBranch_code_options(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.Branch_code_se]);
  ///--------------------State----------------------
  useEffect(() => {
    const Datas = [];

    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setNameList(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  // /------------REgion------------------
  useEffect(() => {
    if (
      EditId == undefined &&
      data.state_id != undefined &&
      data.state_id != ""
    ) {
      // console.log(data.state_id, "ppop");
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: "20",
        page: 1,
        state_id: data.state_id,
        counts: 2,
      };
      dispatch(setRegionActions(payloads));
      setRegionSelected(state.regioncall.RegionDat);
      //  console.log(state.regioncall.RegionDat, "responjearf");
    }
  }, [data.state_id, SearchedVal.regionSearch]);

  ///-------------__Region----Id-----Mul--Select-------------
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    let holdtheregion = [];
    if (selectedVal != null) {
      if (data.state_id != "" || data.state_id != undefined) {
        setMuliselect1(selectedVal);
        selectedVal.map((item) => {
          holdtheregion.push(item.value);
        });

        /// zone
        const matchedZone = multiselect3.filter((item) => {
          return holdtheregion.includes(item.region_id);
        });
        const validZoneIds = matchedZone.map((item) => item.value);

        setMuliselect3(matchedZone);

        setData({
          ...data,
          region_id: holdtheregion,
          zone_id: validZoneIds,
        });
      }
      if (data.state_id == "") {
        setRegionError();
        setMuliselect3([]);
        setData({
          ...data,
          region_id: [],
          zone_id: [],
        });
        setMuliselect1([]);
        // setStateError("*state is required");
      }
    } else {
      setRegionError();
      setMuliselect3([]);
      setData({
        ...data,
        region_id: [],
        zone_id: [],
      });
      setMuliselect1([]);
      // setStateError("*state is required");
    }
  };
  ///----Handle---_Region-----Muliti--Select
  let Region_id_Mul = [];

  useEffect(() => {
    if (
      (EditId == undefined && multiselect1 != undefined) ||
      multiselect1 != null
    ) {
      multiselect1.map((item) => {
        Region_id_Mul.push(item.value);
      });
      setData({
        ...data,
        region_id: Region_id_Mul,
      });
    }
    // console.log(multiselect1, "78ydsah8", Region_id_Mul);
  }, [multiselect1]);

  const [test, setTesting] = useState(Region_id_Mul);
  //--------------------------Zone---
  useEffect(() => {
    // console.log(
    //   state.ZonePart.Zone,
    //   "3333333333333",
    //   multiselect1,
    //   Region_id_Mul,
    //   SearchedVal.zoneSearch
    // );
    if (
      multiselect1 != undefined &&
      multiselect1 != "" &&
      EditId == undefined
    ) {
      //  console.log(data.region_id, "........");

      const payloads = {
        search: SearchedVal.zoneSearch,
        page_size: "20",
        page: 1,
        // region_id: data.region_id,
        region_id: data.region_id,
      };
      console.log(Region_id_Mul, "sadasds");
      dispatch(setZoneActions(payloads));

      setZone(state.ZonePart.Zone);
    }
  }, [multiselect1, data.region_id, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      setZone(state.ZonePart.Zone);
      console.log(Zone, "[56gajdcj", state.ZonePart.Zone);
    }
  }, [state.ZonePart.Zone]);
  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    //  console.log(state.regioncall.RegionDat, "region 32432", data.state_id);
    if (data.state_id != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
          state_id: element.state_id,
          // isDisabled: true,
        });
      });
      //  console.log(objectArray, "regions listes");
      setOptions2(objectArray);
    }
    console.log(data.state_id, "data.state_id");

    if (state.regioncall.RegionDat != undefined && data.state_id != "") {
      // console.log(data.state_id, "state ids");
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
          state_id: element.state_id,
          // isDisabled: false,
        });
      });

      setOptions2(objectArray);
      // console.log(nameList2, "namelist2");
    }
    if (!data.state_id || data.state_id.length == 0) {
      setOptions2([]);
    }
  }, [data.state_id, state.regioncall.RegionDat, SearchedVal.regionSearch]);

  const handlOrganizationList = (selectedVal) => {
    let orgIds = [];

    if (selectedVal != null) {
      selectedVal.map((item) => {
        orgIds.push(item.value);
      });

      setData({
        ...data,
        org_ids: orgIds,
      });
    } else {
      setData({
        ...data,
        org_ids: [],
      });
    }
    setOrganizationSelectedList(selectedVal);
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    console.log(data.region_id, "afasda");
    setZone(state.ZonePart.Zone);
    if (EditId == undefined || EditId == "") {
      if (
        // multiselect1.length == 0

        Region_id_Mul == undefined &&
        Region_id_Mul == "" &&
        Region_id_Mul == []
        //Region_id_Mul != undefined
        //!data.region_id.length > 0 &&
        // EditId == undefined
      ) {
        let objectArray = [];
        state.ZonePart.Zone.forEach((element) => {
          objectArray.push({
            value: element.id,
            label: element.zone_name.toUpperCase(),
            region_id: element.region_id,
            // isDisabled: true,
          });
        });
        setOptions4(objectArray);
      }
      if (
        state.ZonePart.Zone != undefined &&
        Region_id_Mul != undefined &&
        Region_id_Mul != []

        // Region_id_Mul != undefined &&

        // multiselect1.length > 0 ||
        // multiselect1.length == 1

        // Region_id_Mul != undefined &&
        // Region_id_Mul != "" &&
        // Region_id_Mul.length > 0

        // data.region_id.length > 0 &&
        // data.region_id.length == 0 &&
        // data.region_id != "" ||
        // data.region_id != []
      ) {
        //console.log(data.region_id, "check");
        let objectArray = [];
        state.ZonePart.Zone.forEach((element) => {
          objectArray.push({
            value: element.id,
            label: element.zone_name.toUpperCase(),
            region_id: element.region_id,

            // isDisabled: false,
          });
        });
        setOptions4(objectArray);
      }
      console.log(Region_id_Mul, "Region_id_Mul");
      if (!data.region_id || data.region_id?.length == 0) {
        setOptions4([]);
      }
    }
  }, [multiselect1, state.ZonePart.Zone, test, SearchedVal.zoneSearch]);

  //----CHnages-------   Single---Select--------------------------

  const handleAttendanceLocationChange = (e) => {
    if (e != null) {
      //  console.log(e  , "w;eoiwopep",e.value);

      setPanIndiaPlaceVal(e);
      const Ids = [];
      e.map((item) => {
        Ids.push(item.value);
      });
      setData({
        ...data,
        attendance_locations: Ids,
      });
    } else if (e == null) {
      setPanIndiaPlaceVal(null);
      setData({
        ...data,
        attendance_locations: null,
      });
    }
  };
  // console.log(data  , "qoiwueoiuei",);

  ///-----State----uliti---Select
  const handleStateSelectChange = (selectedVal) => {
    setMuliStateselect(selectedVal);
    let HoldtheState = [];
    if (selectedVal != null) {
      selectedVal.map((item) => {
        HoldtheState.push(item.value);
      });

      const matchedRegions = multiselect1.filter((item) => {
        return HoldtheState.includes(item.state_id);
      });
      const validRegionIds = matchedRegions.map((item) => item.value);

      setMuliselect1(matchedRegions);
      const matchedZone = multiselect3.filter((item) => {
        return validRegionIds.includes(item.region_id);
      });
      const validZoneIds = matchedZone.map((item) => item.value);
      setData({
        ...data,
        state_id: HoldtheState,
        region_id: HoldtheState.length === 0 ? [] : validRegionIds,
        zone_id: HoldtheState.length === 0 ? [] : validZoneIds,
      });
      setMuliselect3(matchedZone);
    } else {
      setData({
        ...data,
        state_id: [],
        region_id: [],
        zone_id: [],
      });
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: "ss",
          label: "ss",
          // isDisabled: true,
        });
      });
      //  console.log(objectArray, "regions listes");
      setOptions2([]);

      setMuliselect1([]);
      setMuliselect3([]);
    }
  };
  let State_id = [];
  useEffect(() => {
    if (
      (EditId == undefined && multiselectState != undefined) ||
      multiselectState != null
    ) {
      console.log(multiselectState, "State Selected");
      multiselectState.map((item) => {
        ///  console.log(item.value, "values");
        State_id.push(item.value);
      });

      setData({
        ...data,
        state_id: State_id,
      });
    }
  }, [multiselectState]);

  //----ZOne-----Changes--------------------
  //----------------Zone

  const [MulZone, setMultiZones] = useState();
  const handleZone = (selectedVal) => {
    let holdedthezonevalue = [];

    if (selectedVal != null) {
      selectedVal.map((item) => {
        holdedthezonevalue.push(item.value);
      });

      setData({
        ...data,
        zone_id: holdedthezonevalue,
      });
    } else {
      setData({
        ...data,
        zone_id: [],
      });
    }

    setMuliselect3(selectedVal);

    // console.log(selectedVal, "zoness", data.zone_id, MulZone);
    // selectedVal.map((item)=>{
    //   console.log(item ,"iteeza");
    //   setMultiZones(item.value)
    // })
  };
  let listdata = [];
  useEffect(() => {
    if (
      (EditId == undefined && multiselect3 != undefined) ||
      multiselect3 != null
    ) {
      //  console.log(multiselect3, "test mul3");
      //  listdata.push(multiselect3.value)
      // console.log(listdata, "listedDatas");
      multiselect3.map((test, id) => {
        //  console.log(test.value, "0000");
        listdata.push(test.value);
        console.log(listdata, "666666666666");
        setData({
          ...data,
          zone_id: listdata,
        });
      });
    }
  }, [multiselect3, data.region_id]);
  //   if ( EditId != undefined && multiselect3 != undefined || multiselect3 != null ) {
  //     console.log(SelectedZone, "test mul3");
  //     multiselect3.map((item)=>{
  //       listdata.push(item.value)
  //        console.log(item.value ,"popl,plk,");
  //      })
  // }

  const [SelectedMul, setSelectedMul] = useState([]);
  const handleEditSelected = (selectedVal) => {
    setSelectedMul(selectedVal);
    //   console.log(Selected, "selectedeVall");
    setData({
      ...data,
      user_role: selectedVal.value,
    });
    //console.log(selectedVal, "zzcx", data.role);
    setSelected(selectedVal);
  };

  const handleZoneEdits = (sel) => {
    setZoneMulEdi(sel);
    setZoneSelected(sel);
    let holdedthezonevalue = [];
    if (sel != null) {
      sel.map((item) => {
        holdedthezonevalue.push(item.value);
      });

      setData({
        ...data,
        zone_id: holdedthezonevalue,
      });
    } else {
      setData({
        ...data,
        zone_id: [],
      });
    }
  };
  if (
    (EditId != undefined && SelectedZone != undefined) ||
    SelectedZone != null
  ) {
    //  console.log(SelectedZone, "ZONESSS");
    SelectedZone.map((item) => {
      EditListZone.push(item.value);
      ///  console.log(item.value, "popl,plk,");
    });
  }
  console.log(data, "asdoiasud data");

  const handleKeyDown = (event) => {
    const regex = /^[a-zA-Z0-9 ]$/;
    const key = event.key;

    //--- prevent
    if (
      !regex.test(key) &&
      key !== "Backspace" &&
      key !== "Tab" &&
      key !== "Enter"
    ) {
      event.preventDefault();
    }
  };

  const isValidEmail = validateEmail(data.email);
  console.log(isValidEmail, "isValidEmail");

  const HandleClick = () => {
    // console.log(state.signaturepad.originFile, "9238yreds", data);
    var a = 0;
    if (EditId == undefined) {
      if (data.first_name == "") {
        setFirstError("*First Name is required");
        a = 1;
      }
      if (data.last_name == "") {
        setLastError("*Last Name is required");
        a = 1;
      }
      //     if (data.branch_ids == null || data.branch_ids?.length ==0) {
      //   set_siteCode_err("*Site code is required");
      //   a = 1;
      // }

      if (!data.email && !data.phone_number) {
        setEmailError("*Email or Phone Number is required");
        setphoneeer("*Email or Phone Number is required");
        a = 1;
      }

      // if (data.email == "") {
      //   setEmailError("*Email is required");
      //   a = 1;
      // }
      if (data.phone_number && data.phone_number.length < 10) {
        a = 1;
        setphoneeer("*Phone Number should not less than 10 digits");
      }
      //  if (data.phone_number == "") {
      //   a = 1;
      //   setphoneeer("*Phone Number is required");
      // }

      const isValidEmail = validateEmail(data.email);
      // console.log(isValidEmail, "87e0qweihw");
      if (data.email != "") {
        if (!isValidEmail) {
          setEmailError("*Enter Valid Email ID");
        }
      }
      if (data.email != "" && data.email != null && data.email) {
        if (data.password == "") {
          setPasswordError("*Password is required");
          a = 1;
        }
        const isValidPassword = validatePassword(data.password);

        if (data.password != "" && !isValidPassword) {
          a = 1;
          setPasswordError(
            "*Password must be at least 8 characters long and include an uppercase letter, lowercase letter, digit, and special character.",
          );
        }
      }

      // if (data.state_id == "") {
      //   setRegionError();
      //   setStateError("*State is required");
      // }

      // if (!validator.isEmail(data.email)) {
      //   setEmailError("*Enter valid Email Id");
      //   a = 1;
      // }

      // if (data.total_permissions == "") {
      //   setShiftError("*Shift Permission  is  required");
      //   a = 1;
      // }
      // if (data.user_uid == null || data.user_uid == "") {
      //   setUserErr("*User code is required");
      //   a = 1;
      // }

      if (
        data.user_uid != null &&
        data.user_uid != "" &&
        data.user_uid.length > 25
      ) {
        setUserErr("*User code must not exceed 25 characters.");
        a = 1;
      }

      if (data.personal_leave == "") {
        setPersonslErr("*Personal Leave  is required");
        a = 1;
      }

      if (data.casual_leave == "") {
        setCasualErr("Casual Leave  is required");
        a = 1;
      }

      // if (data.leave_valid_until == "") {
      //   setLeaveErr("*Leave valid  is  required");
      //   a = 1;
      // }
      // if (data.permission_valid_until == "") {
      //   setPermissionErr("*Permission valid  is  required");
      //   a = 1;
      // }

      // if (data.super_admin == true) {
      //   if (data.authorized_person == "") {
      //     setAthoorizedErr("* Authorized Person is required");
      //   }
      // }

      // if (data.authorized_person == "") {
      //   a = 1;

      //   setAthoorizedErr("*Authorized Person is required");
      // }

      // if (data.sub_role == "") {
      //   setSubRollError("*sub  role is required");
      //   a = 1;
      // }

      // if (ManagerSign) {
      //   a = 1;
      //   if (Signs.signature == "") {
      //     a = 1;

      //     // setUserSignError("*Manager Signature is required");
      //     dispatch(SetTheSetUserSignError("*Manager Signature is required"));
      //   }
      // }
      if (data.sub_role == "1") {
        if (
          state.signaturepad.PresentURL == "" ||
          state.signaturepad.PresentURL == null ||
          state.signaturepad.PresentURL == undefined
        ) {
          a = 1;

          setUserSignError("*Manager Signature is required");
          dispatch(SetTheSetUserSignError("*Manager Signature is required"));
          //
        }
      }

      // if (data.user_name == "") {
      //   setUserError("*User Name is required");
      //   a = 1;
      // }

      // if (data.zone_id == "") {
      //   setZoneError("*Zone is required");
      //   a = 1;
      // }
      // if (data.region_id == "") {
      //   // if (Region_id_Mul == "") {
      //   setRegionError("*Region is required");
      //   a = 1;
      // }

      if (data.user_role == "") {
        a = 1;
        setroleError("*User Designation is required");
      }
      if (listdata == []) {
        a = 1;
      }
      let Creationdata = {
        admin_access: data.admin_access,
        authorized_person: data.authorized_person,
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        password: data.password,
        phone_number: data.phone_number,
        region_id: data.region_id,
        state_id: data.state_id,
        sub_role: data.sub_role,
        super_admin: data.super_admin,
        // user_name: data.user_name,
        user_name: null,
        user_role: data.user_role,
        user_uid: data.user_uid,
        zone_id: data.zone_id,
        sign: state.signaturepad.PresentURL,
        unregister_access: false,
        branch_ids: data.branch_ids,
        is_active: data?.is_active,
        personal_leave: 0,
        casual_leave: 0,
        attendance_locations: [],
        pan_india: false,
      };

      const fetchUploadFiles = async () => {
        console.log(state.signaturepad.PresentFullURL, "PresentFullURL");

        await Promise.all(
          state.signaturepad.PresentFullURL.map(async (item) => {
            try {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              dispatch(setThePresentUrlsSended(false));
              dispatch(settheFullPresentUrl([]));
              const data = await response.json();
              console.log("Files uploaded successfully:", data);
            } catch (error) {
              console.error("Error uploading files:", error);
            }
          }),
        );
      };
      if (
        a == 0 &&
        ErrorInde == 0 &&
        state.signaturepad.PresentUrlsSended == true
      ) {
        fetchUploadFiles();
      }
      // console.log(listdata, "eferw45dc", Region_id_Mul, data, Signs);
      if (a == 0 && ErrorInde == 0) {
        form_data.append("data", JSON.stringify(data));

        // form_data.append("sign", Signs.signature);
        form_data.append("sign", state.signaturepad.originFile);

        const payload = {
          data: data,
          listdata,
          Region_id_Mul,
          currentPage: currentPage,
          form_data,
          month: state.ClientBranchIDs.monthANDYEA.month,
          year: state.ClientBranchIDs.monthANDYEA.year,
          white_collar: state.ClientBranchIDs.UserDatas.white_collar,
          search: state.ClientBranchIDs.UserDatas.search,
          state: state.ClientBranchIDs.UserDatas.state,
          region: state.ClientBranchIDs.UserDatas.region,
          zone: state.ClientBranchIDs.UserDatas.zone,
          role_filter: state.ClientBranchIDs?.DesignationUSER
            ? state.ClientBranchIDs?.DesignationUSER?.value
            : "",
          Creationdata: Creationdata,
          Funcations: () => {
            Navigate("/user");
          },
        };
        const newEntry = { updated: true };
        const result = {
          ...TablePositionPersist.UDSUserDatas,
          page: 1, // Set page to 1
          ...newEntry,
        };

        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "UDSUserDatas",
          }),
        );

        dispatch(setUserCreateActions(payload));
        dispatch(settheFullPresentUrl([]));
      }
    }
  };
  const [SignatureEdits, setSignEdits] = useState(false);
  console.log(data, "asodupasdi adpoausd ", UserSignError, Img);

  const HandleEdit = () => {
    var a = 0;

    if (EditId != undefined) {
      // setData({
      // ...data,
      // first_name: data.first_name,
      // last_name: data.last_name,
      // email: data.email,
      // user_role: data.user_role,
      // user_name: data.user_name,
      // state_id: state_id_edit,
      // region_id: RegionEDITS,
      // zone_id: EditListZone,
      // });

      // if (data.user_uid == null || data.user_uid == "") {
      //   setUserErr("*User code is required");
      //   a = 1;
      // }

      //   if (data.branch_ids == null || data.branch_ids?.length ==0) {
      //   set_siteCode_err("*Site code is required");
      //   a = 1;
      // }
      if (!data.email && !data.phone_number) {
        setEmailError("*Email or Phone Number is required");
        setphoneeer("*Email or Phone Number is required");
        a = 1;
      }

      const isValidEmail = validateEmail(data.email);
      // console.log(isValidEmail, "87e0qweihw");
      if (data.email != "") {
        if (!isValidEmail) {
          setEmailError("*Enter Valid Email ID");
        }
      }

      if (data.phone_number != "" && data.phone_number.length < 10) {
        a = 1;
        setphoneeer("*Phone Number should not less than 10 digits");
      }

      if (data.phone_number != "" && data.phone_number.length > 10) {
        a = 1;
        setphoneeer("*Phone Number should not greater than 10 digits");
      }

      if (
        data.user_uid != null &&
        data.user_uid != "" &&
        data.user_uid.length > 25
      ) {
        setUserErr("*User code must not exceed 25 characters.");
        a = 1;
      }
      const isValidPassword = validatePassword(data.password);
      if (data.email != "" && data.email != null && data.email) {
        if (data.password) {
          if (data.password != "") {
            if (!isValidPassword) {
              a = 1;
              setPasswordError(
                "*Password must be at least 8 characters long and include an uppercase letter, lowercase letter, digit, and special character.",
              );
            }
          }
        }
      }
      if (data.first_name == "") {
        setFirstError("*First Name is required");
        a = 1;
      }
      if (data.last_name == "") {
        setLastError("*Last Name is required");
        a = 1;
      }
      if (data.sub_role == "1") {
        if (
          state.signaturepad.PresentURL == "" ||
          state.signaturepad.PresentURL == null ||
          state.signaturepad.PresentURL == undefined
        ) {
          a = 1;

          setUserSignError("*Manager Signature is required");
          dispatch(SetTheSetUserSignError("*Manager Signature is required"));
          //
        }
      }

      // if (data.email == "") {
      //   setEmailError("*Email is required");
      //   a = 1;
      // }

      // if (!validator.isEmail(data.email)) {
      //   setEmailError("*Enter valid mail id");
      //   a = 1;
      // }

      // if (data.authorized_person == "") {
      //   setAthoorizedErr("*Authorized Person is required");
      //   a = 1;
      // }

      // if (data.zone_id == "") {
      // setZoneError("*zone is required");
      // a = 1;
      // }

      // if (data.user_name == "" || data.user_name == null) {
      // setUserError("*User Name is required");
      // a = 1;
      // }

      if (data.user_role == "") {
        a = 1;
        setroleError("*User Designation is required");
      }

      // if(state_id_edit == [] || state_id_edit == ""){
      // setStateError("*state name is required")
      // a = 1;
      // }

      // if (data.state_id == "") {
      // setStateError("*state name is required");
      // a = 1;
      // }
      // if (data.region_id == "") {
      // setRegionError("*Region name is reuired");
      // a = 1;
      // }

      // if(RegionEDITS == [] || RegionEDITS == ""){
      // setRegionError("*Region name is reuired")
      // }

      if (data.password == "") {
        delete data.password;
      }

      const fetchUploadFiles = async () => {
        await Promise.all(
          state.signaturepad.PresentFullURL.map(async (item) => {
            try {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              dispatch(setThePresentUrlsSended(false));
              dispatch(settheFullPresentUrl([]));

              const data = await response.json();
              console.log("Files uploaded successfully:", data);
            } catch (error) {
              console.error("Error uploading files:", error);
            }
          }),
        );
      };
      if (
        a == 0 &&
        ErrorInde == 0 &&
        state.signaturepad.PresentUrlsSended == true &&
        state.signaturepad.ChangesURl == 2
      ) {
        fetchUploadFiles();
      }
      if (a == 0 && ErrorInde == 0) {
        let Creationdata = {
          admin_access: data.admin_access,
          authorized_person: data.authorized_person,
          email: data.email,
          first_name: data.first_name,
          last_name: data.last_name,
          password: data.password,
          phone_number: data.phone_number,
          region_id: data.region_id,
          state_id: data.state_id,
          sub_role: data.sub_role,
          super_admin: data.super_admin,
          user_name: null,
          user_role: data.user_role,
          user_uid: data.user_uid,
          zone_id: data.zone_id,
          sign: state.signaturepad.PresentURL,
          unregister_access: false,
          branch_ids: data.branch_ids,
          personal_leave: 0,
          casual_leave: 0,
          attendance_locations: [],
          pan_india: false,
          is_active: data?.is_active,
        };

        EditFormData.append("data", JSON.stringify(data));
        if (state.signaturepad.ChangesURl == 2) {
          //EditFormData.append("sign", Signs.signature);
          EditFormData.append("sign", state.signaturepad.originFile);
          dispatch(SetChangedUrl(1));
        }
        const newEntry = { updated: true };
        const result = { ...TablePositionPersist.UDSUserDatas, ...newEntry };

        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "UDSUserDatas",
          }),
        );

        const payload = {
          data: data,
          currentPage: currentPage,
          EditId: EditId,
          EditListZone,
          RegionEDITS,
          state_id_edit,
          setShow: setShow,
          EditFormData,
          month: state.ClientBranchIDs.monthANDYEA.month,
          year: state.ClientBranchIDs.monthANDYEA.year,
          white_collar: state.ClientBranchIDs.UserDatas.white_collar,
          search: state.ClientBranchIDs.UserDatas.search,
          state: state.ClientBranchIDs.UserDatas.state,
          region: state.ClientBranchIDs.UserDatas.region,
          zone: state.ClientBranchIDs.UserDatas.zone,
          Creationdata: Creationdata,

          reporintrenders: reporintrenders ? reporintrenders : false,
          role_filter: state.ClientBranchIDs?.DesignationUSER
            ? state.ClientBranchIDs?.DesignationUSER?.value
            : "",
        };
        dispatch(SetUserEditActions(payload));
      }
    }
  };

  ///----Edits-------State -----region----zone---Chnage

  const handleState = (sel) => {
    setStateMul(sel);
    SetStates(sel);
    let HoldtheState = [];
    let stateidforregion = [];

    if (sel != null) {
      sel.map((item) => {
        HoldtheState.push(item.value);
      });
      const matchedRegions = SelectRegion.filter((item) => {
        return HoldtheState.includes(item.state_id);
      });
      const validRegionIds = matchedRegions.map((item) => item.value);

      setRegionMUl(matchedRegions);
      setSlectRegions(matchedRegions);

      /// zone
      const matchedZone = SelectedZone.filter((item) => {
        return validRegionIds.includes(item.region_id);
      });
      const validZoneIds = matchedZone.map((item) => item.value);
      console.log(
        SelectedZone,
        "SelectedZone SelectedZone",
        matchedZone,
        validZoneIds,
      );

      setZoneMulEdi(matchedZone);
      setZoneSelected(matchedZone);

      setData({
        ...data,
        state_id: HoldtheState,
        region_id: HoldtheState.length === 0 ? [] : validRegionIds,
        zone_id: HoldtheState.length === 0 ? [] : validZoneIds,
      });
    } else {
      setZoneMulEdi([]);
      setZoneSelected([]);
      setRegionMUl([]);
      setSlectRegions([]);

      setData({
        ...data,
        state_id: [],
        region_id: [],
        zone_id: [],
      });
    }
  };

  //----Handle-----Muliti--select---in the state_id----------------

  useEffect(() => {
    if (
      (EditId != undefined && SelectedStates != undefined) ||
      SelectedStates != null
    ) {
      console.log(SelectedStates, "Reginssds Reginssds");
      SelectedStates.map((item) => {
        state_id_edit.push(item.value);
        State_idObject.push(item.value);
      });
    }
  }, [SelectedStates]);

  console.log(
    State_idObject,
    state_id_edit,
    "asuoydoiausdoi State_idObject",
    data,
    SelectedStates,
    EditId,
  );

  // /------------REgion------------------
  useEffect(() => {
    if (
      EditId != undefined &&
      SelectedStates != undefined &&
      SelectedStates != ""
    ) {
      //  console.log(data.state_id, "ppop");
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: 20,
        page: 1,
        state_id: data.state_id,
        counts: 2,
      };
      dispatch(setRegionActions(payloads));
      setRegionSelected(state.regioncall.RegionDat);
      //   console.log(state.regioncall.RegionDat, "responjearf");
    }
  }, [SelectedStates, data.state_id, SearchedVal.regionSearch]);

  const handleRegionSelected = (sel) => {
    setRegionMUl(sel);
    setSlectRegions(sel);
    console.log(sel, "ASOWEYQIUWYE sel", nameList2);
    let holdtheregion = [];
    if (sel != null) {
      sel.map((item) => {
        holdtheregion.push(item.value);
      });

      /// zone
      const matchedZone = SelectedZone.filter((item) => {
        return holdtheregion.includes(item.region_id);
      });
      const validZoneIds = matchedZone.map((item) => item.value);

      setZoneMulEdi(matchedZone);
      setZoneSelected(matchedZone);

      setData({
        ...data,
        region_id: holdtheregion,
        zone_id: holdtheregion.length === 0 ? [] : validZoneIds,
      });
    } else {
      setZoneMulEdi([]);
      setZoneSelected([]);

      setData({
        ...data,
        region_id: [],
        zone_id: [],
      });
    }
    //   console.log(SelectRegion, "Region isdd");
    SelectRegion.map((item) => {
      RegionEDITS.push(item.value);
      // console.log(item.value, "region IDDD EDITS");
    });
    //  console.log(RegionEDITS, "sdfhsljd797");
  };
  if (
    (EditId != undefined && SelectRegion != undefined) ||
    SelectRegion != null
  ) {
    //  console.log(SelectRegion, "Reginssds");
    SelectRegion.map((item) => {
      RegionEDITS.push(item.value);
      Region_IDS.push(item.value);
      ///   console.log(item.value, "Regionsss,", RegionEDITS);
    });
  }

  //--------------------------Zone---
  useEffect(() => {
    if (
      SelectRegion != undefined &&
      SelectRegion != "" &&
      EditId != undefined
    ) {
      console.log(data.region_id, "........");
      const payloads = {
        search: SearchedVal.zoneSearch,
        page_size: "",
        page: 1,
        region_id: RegionEDITS,
      };
      dispatch(setZoneActions(payloads));
      console.log(state.ZonePart.Zone, "3333333333333");
      setZone(state.ZonePart.Zone);
    }
  }, [SelectRegion, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (SelectRegion != undefined && EditId != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
          region_id: element.region_id,

          // isDisabled: true,
        });
      });
      setOptions4(objectArray);
      // console.log(objectArray, "objectss");
    }

    if (
      state.ZonePart.Zone != undefined &&
      SelectRegion != "" &&
      EditId != undefined
    ) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
          region_id: element.region_id,

          // isDisabled: false,
        });
      });
      setOptions4(objectArray);
    }
    if (EditId != undefined) {
      if (!SelectRegion || SelectRegion.length == 0) {
        setOptions4([]);
      }
    }
  }, [SelectRegion, state.ZonePart.Zone, SearchedVal.zoneSearch]);

  const [ErrorsStateRegion, setErrorsStateRegion] = useState("");
  useEffect(() => {
    if (
      state.UserRetrieve.userRetrireve.id == EditId &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.state_id != undefined &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.state_id != undefined &&
      state.UserRetrieve.userRetrireve.region_id != undefined &&
      state.UserRetrieve.userRetrireve.region_id != null &&
      state.UserRetrieve.userRetrireve.region_id != [] &&
      state.UserRetrieve.userRetrireve.state_id != []
    ) {
      state.UserRetrieve.userRetrireve.state_id.map((item) => {
        objectState.push({
          value: item.id,
          label: item.state_name,
        });

        State_idObject.push(item.id);
      });
      console.log(objectState, "qasdx");
      SetStates(objectState);

      let objectRegion = [];
      let region_idEdit = [];
      state.UserRetrieve.userRetrireve.region_id.map((item) => {
        objectRegion.push({
          value: item.id,
          label: item.region_name,
          state_id: item.state_id,
        });
        region_idEdit.push(item.id);
        Region_IDS.push(item.id);
      });

      setSlectRegions(objectRegion);
    } else {
      setErrorsStateRegion("State Id and Region ID is undefined");
    }
  }, [state.UserRetrieve.userRetrireve.id]);

  ///----ZONE=====EDTssss
  let listEDITdata = [];

  useEffect(() => {
    /// console.log(state.UserRetrieve.userRetrireve, "user Edits Retrieve");

    if (state.UserRetrieve.userRetrireve.id != undefined) {
      let objectedit = [];

      let objectZone = [];

      console.log(state.UserRetrieve.userRetrireve, "zoness", objectZone);
      state.UserRetrieve.userRetrireve.zone_id.map((item) => {
        objectZone.push({
          value: item.id,
          label: item.zone_name,
          region_id: item.region_id,
        });
        EditListZone.push(item.id);
      });

      setZoneSelected(objectZone);
    }
  }, [state.UserRetrieve.userRetrireve.id]);

  /////-----User--------------------_EDIT--zones
  useEffect(() => {
    if (
      EditId != undefined &&
      state.UserRetrieve.userRetrireve.id != undefined
    ) {
      state.UserRetrieve.userRetrireve.zone_id.map((item) => {
        // listEDITdata.push({
        //   value: item.id,
        //   label: item.zone_name,
        // });
      });
      //   console.log(listEDITdata, "69yiuhj7iu");
      if (
        (ZoneMulEdi != undefined && EditId != undefined) ||
        ZoneMulEdi != null
      ) {
        //   console.log(ZoneMulEdi, "Zone-------------EDITSSS");

        SelectedZone.map((item) => {
          EditListZone.push(item.value);
          //   console.log(item.value, "popl,plk,");
        });
      }
      // console.log(EditListZone, "wadajsdnlk");
    }
  }, [state.UserRetrieve.userRetrireve]);
  useEffect(() => {
    if (
      EditId != undefined &&
      state.UserRetrieve.userRetrireve != undefined &&
      state.UserRetrieve.userRetrireve.zone_id != undefined
    ) {
      state.UserRetrieve.userRetrireve.zone_id.map((item) => {
        //console.log(item, "ut67yui");
        EditListZone.push(item.id);
      });

      //  console.log(EditListZone, "editZOnesss");
    }
  }, [state.UserRetrieve.userRetrireve.id]);

  ////---___Signature-----Popup---------------------
  const [SignaturePopups, setSignaturePopup] = useState(false);

  const HandelPopup = () => {
    setSignaturePopup(!SignaturePopups);
    dispatch(SetSignaturePops(!SignaturePopups));
  };

  const ImageUrlSign = (fileName, img) => {
    console.log(img, "oljbmn ", fileName);
    if (EditId == undefined) {
      var file = img;
      var reader = new FileReader();
      reader.onloadend = function () {
        setImg(reader.result);
        console.log(reader.result, "results");
      };
      reader.readAsDataURL(file);
    }
    if (EditId != undefined) {
      var file = img;
      var reader = new FileReader();
      reader.onloadend = function () {
        console.log(reader.result, "results");
        setImg(reader.result);
      };
      reader.readAsDataURL(file);
      setSign({
        ...Signs,
        signature: img,
      });
      setSignEdits(true);
    }

    // setImg(img); //img
    setSign({
      ...Signs,
      signature: img, ///filename
    });
    console.log(Signs, "sign");
  };

  const Counting = () => {
    const count = CountingNum + 1;
    setCountingNum(`${count}.png`);
    dispatch(SetTheCountNumbersNam(`${count}.png `));
    // console.log(state.signaturepad.originFile, "namezx");
  };
  useEffect(() => {
    dispatch(SetTheCountNumbersNam(""));
    dispatch(setTheSingatureFilename(""));
  }, []);
  useEffect(() => {
    if (EditId != undefined) {
      console.log(Signs, "Images", state.signaturepad.ChangesURl);
      if (state.signaturepad.ChangesURl == 2) {
        setImg(state.signaturepad.fileName);
        setSign({
          ...Signs,
          signature: state.signaturepad.fileName,
        });
      }
    }
  }, [state.signaturepad.fileName, state.signaturepad.ChangesURl]);
  return (
    <>
      <>
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="col BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          {EditId == undefined ? (
                            <span className="UserCreated"> User</span>
                          ) : (
                            <span className="UserCreated">User </span>
                          )}
                        </div>
                        {/* <div className='CloseIcon' onClick={e => window.location.href="/user"}>
                <CloseOutlinedIcon />
              </div> */}
                      </div>
                      <div className="Modal-Body Modal-bodyUserCRUD">
                        <div className="row">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              First Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="first_name"
                              value={data.first_name}
                              onChange={(e) => {
                                HandleChanges(e);
                                setFirstError("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {FirstError}{" "}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Last Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              value={data.last_name}
                              name="last_name"
                              onChange={(e) => {
                                HandleChanges(e);
                                setLastError("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {lastError}{" "}
                            </p>
                          </div>
                          {EditId == undefined ? (
                            <>
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustomUsername"
                                  class="form-label"
                                >
                                  Email
                                  {(data?.phone_number != "" &&
                                    data.email != "") ||
                                  (data?.phone_number == "" &&
                                    data?.email == "") ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : (
                                    <>
                                      {data?.phone_number != "" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : data?.email != "" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </label>
                                <div class="input-group has-validation">
                                  <span
                                    class="input-group-text"
                                    id="inputGroupPrepend"
                                  >
                                    @
                                  </span>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustomUsername"
                                    required
                                    value={data.email}
                                    autocomplete="off"
                                    name="email"
                                    onChange={(e) => {
                                      setphoneeer("");
                                      HandleChanges(e);
                                      if (e.target.value == "") {
                                        setEmailError("");
                                        setPasswordError("");
                                        setData({
                                          ...data,
                                          password: "",
                                          email: "",
                                        });
                                      }
                                    }}
                                  />
                                </div>

                                <p className="Error"> {emailError} </p>
                              </div>

                              <div class="col-sm-3 mt-3">
                                <label
                                  for="validationCustom04"
                                  class="form-label"
                                >
                                  Password
                                  {data?.email != "" && data?.email && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>

                                <div class="Password-Filed">
                                  <input
                                    type="text"
                                    className={` form-control  ${
                                      viewpass ? "activate" : "notactivate"
                                    }`}
                                    required
                                    autocomplete="off"
                                    id="outlined-adornment-password"
                                    value={data.password}
                                    name="password"
                                    onChange={(e) => {
                                      HandleChanges(e);
                                      // setPasswordError("");
                                    }}
                                    disabled={
                                      data?.email == "" || isValidEmail == false
                                        ? true
                                        : false
                                    }
                                  />

                                  <i className="icon">
                                    {viewpass ? (
                                      <RemoveRedEyeIcon
                                        onClick={(e) => setViewpass(!viewpass)}
                                      ></RemoveRedEyeIcon>
                                    ) : (
                                      <VisibilityOffIcon
                                        onClick={(e) => setViewpass(!viewpass)}
                                      ></VisibilityOffIcon>
                                    )}
                                  </i>
                                </div>
                                <p className="Error"> {PasswordError} </p>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustomUsername"
                                  class="form-label"
                                >
                                  Email
                                  {/* {data?.phone_number !="" ? "":
                                 <span style={{ color: "red" }}>*</span>
                                  } */}
                                  {(data?.phone_number != "" &&
                                    data.email != "") ||
                                  (data?.phone_number == "" &&
                                    data?.email == "") ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : (
                                    <>
                                      {data?.phone_number != "" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : data?.email != "" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </label>
                                <div class="input-group has-validation">
                                  <span
                                    class="input-group-text"
                                    row
                                    id="inputGroupPrepend"
                                  >
                                    @
                                  </span>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustomUsername"
                                    required
                                    value={data.email}
                                    autocomplete="off"
                                    name="email"
                                    onChange={(e) => {
                                      setphoneeer("");
                                      HandleChanges(e);
                                      // setEmailError("");
                                      if (e.target.value == "") {
                                        setEmailError("");
                                        setPasswordError("");
                                        setData({
                                          ...data,
                                          password: "",
                                          email: "",
                                        });
                                      }
                                    }}
                                  />
                                </div>
                                <p className="Error"> {emailError} </p>
                              </div>

                              <div class="col-sm-3 mt-3">
                                <label
                                  for="validationCustom04"
                                  class="form-label"
                                >
                                  Password
                                  {EditId ? (
                                    ""
                                  ) : (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>

                                <div class="Password-Filed">
                                  <input
                                    type="text"
                                    className={` form-control  ${
                                      viewpass ? "activate" : "notactivate"
                                    }`}
                                    required
                                    autocomplete="off"
                                    id="outlined-adornment-password"
                                    value={data.password}
                                    name="password"
                                    onChange={(e) => {
                                      HandleChanges(e);
                                      // setPasswordError("");
                                    }}
                                    disabled={
                                      data?.email == "" || isValidEmail == false
                                        ? true
                                        : false
                                    }
                                  />

                                  <i className="icon">
                                    {viewpass ? (
                                      <RemoveRedEyeIcon
                                        onClick={(e) => setViewpass(!viewpass)}
                                      ></RemoveRedEyeIcon>
                                    ) : (
                                      <VisibilityOffIcon
                                        onClick={(e) => setViewpass(!viewpass)}
                                      ></VisibilityOffIcon>
                                    )}
                                  </i>
                                </div>
                                <p className="Error"> {PasswordError} </p>
                              </div>
                            </>
                          )}
                        </div>

                        {EditId == undefined ? (
                          <div className="row">
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label-Header"
                              >
                                Phone Number
                              </label>
                              {data?.email == "" && !data?.email && (
                                <span style={{ color: "red" }}>*</span>
                              )}

                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="phone_number"
                                // onKeyDown={(evt) =>
                                //   ["e", "E", "+", "-"].includes(evt.key) &&
                                //   evt.preventDefault()
                                // }

                                step="1"
                                onKeyDown={(evt) => {
                                  preventZoom(evt);
                                }}
                                onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                ref={inputRef}
                                // onChange={(e) => {
                                //   if (e.target.value.length <= 10) {
                                //     HandleChanges(e);
                                //     setphoneeer("");
                                //   }
                                // }}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Regular expression to validate phone number
                                  const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                  setphoneeer("");
                                  setEmailError("");
                                  setPasswordError("");
                                  // Check if value exceeds 10 digits or is invalid
                                  if (
                                    value.length <= 10 &&
                                    (phoneRegex.test(value) || value === "")
                                  ) {
                                    HandleChanges(e);
                                  }
                                }}
                                value={data.phone_number}
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {phonenmErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                User code
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                autoComplete="off"
                                name="user_uid"
                                value={data.user_uid}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length > 25) {
                                    e.preventDefault();
                                    setUserErr(
                                      "*User code must not exceed 25 characters.",
                                    );
                                    setErrInde(1);
                                  } else {
                                    setUserErr("");
                                    setErrInde(0);
                                    HandleChanges(e);
                                  }
                                }}
                                onKeyDown={handleKeyDown}
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {UserErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                User Designation
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                // options={options}
                                // onChange={handleChange}
                                onSelect={(e) => setMuliselect(e)}
                                onChange={(e) => {
                                  handleSelectChange(e);
                                  setroleError("");
                                }}
                                options={nameList}
                                labelledBy="Select"
                                onInputChange={handleInputChangeRole}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {roleError}
                              </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label-Header"
                              >
                                Authorized Person
                              </label>
                              <Select
                                className="Selects"
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                  padding: "70vh",
                                }}
                                onSelect={(e) => setMuliuserselect(e)}
                                onChange={(e) => {
                                  handleSelectuserChange(e);
                                  setAthoorizedErr("");
                                }}
                                onInputChange={handleInputChangeCreateuser}
                                options={OptionsUser}
                                labelledBy="Select"
                                value={AuthorizedPer}
                                isClearable={true}
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {AuthorizedErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Kyc Role
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                options={Options}
                                // onChange={handleChange}
                                onSelect={(e) => {
                                  setsubrolselect(e);
                                }}
                                value={subrollSelect}
                                onChange={(e) => {
                                  setData({
                                    sub_role: e.value,
                                  });
                                  handleSubRollSelect(e);
                                  setsubrolselect(e);
                                  setSubRollError("");
                                }}
                                labelledBy="Select"
                              />

                              <p className="Error">{SubRollError} </p>
                            </div>

                            <div
                              className="col-sm-3 mt-5"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                paddingLeft: "40px",
                                alignItems: "flex-start",
                                height: "fit-content",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="isActiveCheck"
                                style={{ marginTop: "3px" }}
                                checked={data?.is_active ?? false}
                                onChange={(e) =>
                                  setData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                  }))
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="isActiveCheck"
                              >
                                Active
                              </label>
                            </div>

                            {/* ////-----Permissions----------------- */}
                            {/* <div
                              className="col-sm-6 Permissions"
                     
                            >


                              <div className="row">
                                <div className="col-6 mt-4">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Personal Leave (Per Month)
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="number"
                                    onKeyDown={(evt) => {
                                      preventZoom(evt)

                                    }}
                                    onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                    onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                                    ref={inputRef}
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="personal_leave"
                                    value={
                                      data.personal_leave
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Regular expression to validate phone number
                                      const phoneRegex = /^[0-9]{1,10}$/;
                                      setPersonslErr("");
                                      // Check if value exceeds 10 digits or is invalid
                                      if (value.length <= 1 && (phoneRegex.test(value) || value === '')) {
                                        HandleChanges(e);
                                      }
                                    }}

                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {personalLevaeErr} </p>
                                </div>
                                <div className="col-6 mt-4">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Casual Leave (Per Month)
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="number"
                                    onKeyDown={(evt) => {
                                      preventZoom(evt)

                                    }}
                                    onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                    onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                                    ref={inputRef}

                                    class="form-control"
                                    required
                                    autocomplete="off"
                                    value={
                                      data.casual_leave
                                    }
                                    name="casual_leave"
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Regular expression to validate phone number
                                      const phoneRegex = /^[0-9]{1,10}$/;
                                      setCasualErr("");
                                      // Check if value exceeds 10 digits or is invalid
                                      if (value.length <= 1 && (phoneRegex.test(value) || value === '')) {
                                        HandleChanges(e);
                                      }
                                    }}
                                  />
                                  <p className="Error" style={{ marginLeft: "-5px" }}>
                                    {casualErro} </p>
                                </div>
                              </div>


                            </div> */}

                            {/* -------Options----------------- */}

                            {/* <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Attendance Location
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  handleAttendanceLocationChange(e);
                                }}
                                isMulti
                                options={PanIndiaPlace}
                                labelledBy="Select"
                                value={PanIndiaPlaceVal}
                                isDisabled={data.pan_india || data.sub_role == 3}
                                onInputChange={(val)=>{
                                  setSearchDebounance({
                                    ...SearchDebounance,
                                    Attendancelocation_se:val
                                  })
                                }}
                              />
                              <div className="col-6 p-0">
                                <label
                                  style={{
                                    marginRight: "10px",
                                    marginTop: "12px",
                                  }}
                                >
                                  Pan India
                                </label>
                                <input
                                  type="checkbox"

                                  name="pan_india"
                                  onChange={(e) => {
                                    setPanIndia(!PanIndia);
                                    HandleChanges(e, PanIndia);
                                  }}
                                  checked={data.pan_india}
                                  isDisabled={data.sub_role == 3}

                                />
                              </div>


                            </div> */}

                            {/* ---------------Single----Selecte---------------- */}
                            {/* <div className="col-6 mt-3"> */}
                            {/* <label for="validationCustom01" class="form-label"> */}
                            {/* State Name */}
                            {/* <span style={{ color: "red" }}>*</span> */}
                            {/* </label> */}
                            {/* <Select */}
                            {/* // className="Selects" */}
                            {/* // styles={{ position: "relative", top: "60px" }} */}
                            {/* //  */}
                            {/* //  */}
                            {/* // onSelect={(e) => setMuliStateselect(e)} */}
                            {/* // onChange={(e) => { */}
                            {/* // handleStateSelectChange(e); */}
                            {/* // setStateError(""); */}
                            {/* // }} */}
                            {/* // options={NameListState} */}
                            {/* // labelledBy="Select" */}
                            {/* // /> */}
                            {/* <p className="Error">{stateerror}</p> */}
                            {/* </div> */}

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Site Code
                              </label>
                              <Select
                                className="Selects"
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                onChange={(e) => {
                                  Handlethe_site_code(e);
                                  set_siteCode_err("");
                                }}
                                isMulti
                                options={Branch_code_options}
                                value={Branch_codeVal}
                                closeMenuOnSelect={false}
                                onInputChange={(val) => {
                                  setSearchDebounance({
                                    ...SearchDebounance,
                                    Branch_code_se: val,
                                  });
                                }}
                                labelledBy="Select"
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {site_code_err}{" "}
                              </p>
                            </div>

                            {/* ---------------Muliti ----Selecte---------------- */}
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                State
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onSelect={(e) => setMuliStateselect(e)}
                                onChange={(e) => {
                                  handleStateSelectChange(e);
                                  setStateError("");
                                }}
                                isMulti
                                options={NameListState}
                                onInputChange={handleInputChange}
                                labelledBy="Select"
                                value={multiselectState}
                                closeMenuOnSelect={false}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {stateerror}
                              </p>
                            </div>
                            {/* ---------------Single----Selecte---------------- */}
                            {/* <div className="col-6 mt-3"> */}
                            {/* <label for="validationCustom01" class="form-label"> */}
                            {/* Region Name */}
                            {/* <span style={{ color: "red" }}>*</span> */}
                            {/* </label> */}
                            {/* <Select */}
                            {/* // className="Selects" */}
                            {/* // styles={{ position: "relative", top: "60px" }} */}
                            {/* // disabled={true} */}
                            {/* // onChange={(e) => { */}
                            {/* // handelRegionSlect(e);
                                // setRegionError("");
                              // }}
                              // options={nameList2}
                              // labelledBy="Select"
                            // /> */}
                            {/* <p className="Error">{RegionError}</p> */}
                            {/* </div> */}

                            {/* ---------------Muliti----Selecte---------------- */}
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Region
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  handelRegionSlect(e);
                                  setRegionError("");
                                }}
                                isMulti
                                options={nameList2}
                                onInputChange={handleInputRegion}
                                labelledBy="Select"
                                closeMenuOnSelect={false}
                                value={multiselect1}
                                // placeholder={
                                //   data.state_id != undefined &&
                                //   data.state_id.length > 0
                                //     ? "search"
                                //     : "without selected state you can't select Region"
                                // }
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {RegionError}
                              </p>
                            </div>

                            {/* <div className="col mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Zone Name
                                  </label>
                                  <Select
                                    className="Selects"
                                    styles={{ position: "relative", top: "60px" }}
                                    // options={options}
                                    // onChange={handleChange}
                                    onSelect={(e) => setZoneMulEdi(e)}
                                    onChange={(e) => {
                                      handleZoneEdits(e);
                                      setZoneError("");
                                    }}
                                    options={nameList4}
                                    value={SelectedZone}
                                    labelledBy="Select"
                                  />
                                  <p className="Error">{ZoneError}</p>
                                </div>
                         */}

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Zone
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                // options={options}
                                // onChange={handleChange}
                                onSelect={(e) => setMuliselect3(e)}
                                onChange={(e) => {
                                  handleZone(e);
                                  setZoneError("");
                                }}
                                options={nameList4}
                                labelledBy="Select"
                                closeMenuOnSelect={false}
                                isMulti
                                onInputChange={handleInputZone}
                                value={multiselect3}
                                // placeholder={
                                //   "without selected state and region  you can't select Zone"
                                // }
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {ZoneError}
                              </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                                style={{ fontSize: "19px" }}
                              >
                                Organization
                              </label>
                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  handlOrganizationList(e);
                                }}
                                options={Organization_options}
                                labelledBy="Select"
                                onInputChange={(val) => {
                                  setSearchDebounance({
                                    ...SearchDebounance,
                                    organization_search: val,
                                  });
                                }}
                                isMulti={true}
                                isClearable={true}
                                value={organizationSelectedList}
                              />
                              {console.log(
                                data,
                                "dkjaskjdjaskd",
                                organizationSelectedList,
                              )}
                            </div>

                            {/* <div className="col-sm-3 field-div ActiveStatusSub">
                              <label htmlFor="isActiveToggle" className="toggleLabel">Unregister Access                                          <input
                                type="checkbox"
                                id="isActiveToggle"
                                name="isActive"
                                onChange={Handletoggle}


                                className="toggleInput"
                                checked={data.unregister_access}
                              /></label>
                              <div className="toggleSwitch">

                                <span className="slider"></span>
                              </div>
                            </div> */}

                            {fieldaccess == 0 ? (
                              <>
                                <div
                                  className="col-sm-3"
                                  style={{ marginTop: "15px" }}
                                >
                                  <label>Access List</label>
                                  <MultiSelect
                                    key={
                                      optionsForAdim.length +
                                      "-" +
                                      data.super_admin
                                    } // <---- FIX
                                    options={optionsForAdim}
                                    selectedValues={selectedOptions}
                                    onSelect={handleChange}
                                    onRemove={handleChange}
                                    labelledBy="Select"
                                    displayValue="name"
                                    placeholder=""
                                    isObject={true}
                                    avoidHighlightFirstOption={true}
                                  />

                                  {/* {SuperAdminOptions ? (
                                    <div className="col-6">
                                      <label
                                        style={{
                                          marginRight: "10px",
                                          marginTop: "12px",
                                        }}
                                      >
                                        Super Admin
                                      </label>
                                      <input
                                        type="checkbox"
                                        style={{cursor:"pointer"}}
                                        //class="form-control"
                                        //  id="validationCustom01"
                                        name="super_admin"
                                        onChange={(e) => {
                                          setsupertrue(!superTrue);
                                          HandleChangesAdminRights(e, !data.super_admin);
                                        }}
                                        checked={data.super_admin}
                                      />
                                    </div>
                                  ) : null} */}
                                </div>
                              </>
                            ) : null}

                            {ManagerSign ? (
                              <div className="col-6 mt-3 ">
                                <label>
                                  {" "}
                                  Signature
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="col SignatureFields p-0 ">
                                  <div className="Image">
                                    {!state.signaturepad.SignaturePopups &&
                                    state.signaturepad.fileName != null ? (
                                      <div className="">
                                        <img
                                          //  src={Img}
                                          src={state.signaturepad.fileName}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                  {/* <p style={{ color: "red", width: "100%" }}>
                                    {UserSignError}
                                  </p> */}
                                  <p style={{ color: "red", width: "100%" }}>
                                    {state.signaturepad.setUserSignError}
                                  </p>
                                  <div className="Inner_signable">
                                    <button
                                      className="Signatures ButtonCSS"
                                      onClick={(e) => {
                                        HandelPopup(e);
                                        Counting();
                                      }}
                                      style={{
                                        background: "#234492",
                                        color: "#ffff  !important",
                                      }}
                                    >
                                      Click here to sign
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <>
                            <div className="row">
                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label-Header"
                                >
                                  Phone Number
                                  {data?.email == "" && !data?.email && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}{" "}
                                </label>
                                <input
                                  type="number"
                                  ref={inputRef}
                                  onKeyDown={(evt) => {
                                    preventZoom(evt);
                                  }}
                                  onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                  onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="phone_number"
                                  // max={10}
                                  // step="1"

                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Regular expression to validate phone number
                                    const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                    setphoneeer("");
                                    setEmailError("");
                                    // Check if value exceeds 10 digits or is invalid
                                    if (
                                      value.length <= 10 &&
                                      (phoneRegex.test(value) || value === "")
                                    ) {
                                      HandleChanges(e);
                                    }
                                  }}
                                  value={data.phone_number}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {phonenmErr}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  User code
                                  {/* <span style={{ color: "red" }}>*</span> */}
                                </label>

                                <input
                                  type="text"
                                  className="form-control"
                                  id="validationCustom01"
                                  autoComplete="off"
                                  name="user_uid"
                                  value={data.user_uid}
                                  onChange={(e) => {
                                    const inputValue = e.target.value;
                                    if (inputValue.length > 25) {
                                      e.preventDefault();
                                      setUserErr(
                                        "*User code must not exceed 25 characters.",
                                      );
                                      setErrInde(1);
                                    } else {
                                      setUserErr("");
                                      setErrInde(0);
                                      HandleChanges(e);
                                    }
                                  }}
                                  onKeyDown={handleKeyDown}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {UserErr}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  User Designation
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  className="Selects"
                                  styles={{ position: "relative", top: "60px" }}
                                  // options={options}
                                  // onChange={handleChange}

                                  ///onRemove={(e) => setMuliselect(e)}
                                  onSelect={(e) => setSelectedMul(e)}
                                  onChange={(e) => {
                                    handleEditSelected(e);
                                    setroleError("");
                                  }}
                                  options={nameList}
                                  value={Selected}
                                  labelledBy="Select"
                                  onInputChange={handleInputChangeRole}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {roleError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label-Header"
                                >
                                  Authorized Person
                                </label>
                                <Select
                                  className="Selects"
                                  styles={{
                                    position: "relative",
                                    top: "60px",
                                    padding: "70vh",
                                  }}
                                  onSelect={(e) => setMuliuserselect(e)}
                                  onChange={(e) => {
                                    handleSelectuserChange(e);
                                    setAthoorizedErr("");
                                  }}
                                  onInputChange={handleInputChangeCreateuser}
                                  options={OptionsUser}
                                  labelledBy="Select"
                                  value={AuthorizedPer}
                                  isClearable={true}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {AuthorizedErr}
                                </p>
                              </div>

                              {/* -------Options----------------- */}
                              <div className="col-sm-3  mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Kyc Role
                                </label>
                                <Select
                                  className="Selects"
                                  styles={{
                                    position: "relative",
                                    top: "60px",
                                  }}
                                  options={Options}
                                  // onChange={handleChange}
                                  onSelect={(e) => {
                                    setsubrolselect(e);
                                  }}
                                  value={subrollSelect}
                                  onChange={(e) => {
                                    handleSubRollEDITSelect(e);
                                    setSubRollError("");
                                  }}
                                  //value={subrollSelect}
                                  labelledBy="Select"
                                />
                                <p className="Error"> {SubRollError} </p>
                              </div>

                              <div
                                className="col-sm-3 mt-5"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingLeft: "40px",
                                  alignItems: "flex-start",
                                  height: "fit-content",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="isActiveCheck"
                                  style={{ marginTop: "3px" }}
                                  checked={data?.is_active ?? false}
                                  onChange={(e) =>
                                    setData((prev) => ({
                                      ...prev,
                                      is_active: e.target.checked,
                                    }))
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="isActiveCheck"
                                >
                                  Active
                                </label>
                              </div>

                              {/* ------Singel---Multi---Select--State----Edits */}
                              {/* <div className="col mt-3"> */}
                              {/* <label */}
                              {/* // for="validationCustom01" */}
                              {/* // class="form-label" */}
                              {/* // > */}
                              {/* State Name */}
                              {/* </label> */}
                              {/* <Select */}
                              {/* // className="Selects" */}
                              {/* // styles={{ position: "relative", top: "60px" }} */}
                              {/* options={options} */}
                              {/* onChange={handleChange} */}
                              {/* // onSelect={(e) => setStateMul(e)} */}
                              {/* // onChange={(e) => { */}
                              {/* // handleState(e); */}
                              {/* // setStateError(""); */}
                              {/* // }} */}
                              {/* // options={nameList} */}
                              {/* // value={SelectedStates} */}
                              {/* // labelledBy="Select" */}
                              {/* // /> */}
                              {/* <p className="Error">{stateerror}</p> */}
                              {/* </div> */}

                              {/* ----Single----Select-----Edits------------------ */}
                              {/* <div className="col mt-3"> */}
                              {/* <label */}
                              {/* // for="validationCustom01" */}
                              {/* // class="form-label" */}
                              {/* // > */}
                              {/* Region Name */}
                              {/* </label> */}
                              {/* <Select */}
                              {/* // className="Selects" */}
                              {/* // styles={{ position: "relative", top: "60px" }} */}
                              {/* options={options} */}
                              {/* onChange={handleChange} */}
                              {/* // onSelect={(e) => setRegionMUl(e)} */}
                              {/* // onChange={(e) => { */}
                              {/* // handleRegionSelected(e); */}
                              {/* // setRegionError(""); */}
                              {/* // }} */}
                              {/* // options={nameList2} */}
                              {/* // value={SelectRegion} */}
                              {/* // labelledBy="Select" */}
                              {/* // /> */}
                              {/* <p className="Error">{RegionError}</p> */}
                              {/* </div> */}
                              {EditId != undefined ? (
                                <>
                                  {/* ----------MUliti-----Select------Region in Edit------------ */}
                                  <>
                                    {/* ////-----Permissions----------------- */}
                                    {/* <div
                                      className="col-sm-6 Permissions"
                                      style={{
                                        marginTop: "15px",
                                      }}
                                    >

                                      <div className="row">
                                        <div className="col-6 mt-1">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Personal Leave (Per Month)
                                            <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                            type="number"
                                            // step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt)

                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                                            ref={inputRef}

                                            class="form-control"
                                            id="validationCustom01"
                                            autocomplete="off"
                                            name="personal_leave"
                                            value={
                                              data.personal_leave
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              // Regular expression to validate phone number
                                              const phoneRegex = /^[0-9]{1,10}$/;
                                              setPersonslErr("");
                                              // Check if value exceeds 10 digits or is invalid
                                              if (value.length <= 1 && (phoneRegex.test(value) || value === '')) {
                                                HandleChanges(e);
                                              }
                                            }}


                                          />
                                          <p className="Error" style={{ marginLeft: "-5px" }}>
                                            {" "}
                                            {personalLevaeErr}{" "}
                                          </p>
                                        </div>
                                        <div className="col-6 mt-1">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Casual Leave (Per Month)
                                            <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                            type="number"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt)

                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                                            ref={inputRef}


                                            class="form-control"
                                            required
                                            autocomplete="off"
                                            value={
                                              data.casual_leave
                                            }
                                            name="casual_leave"
                               
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              // Regular expression to validate phone number
                                              const phoneRegex = /^[0-9]{1,10}$/;
                                              setCasualErr("");
                                              // Check if value exceeds 10 digits or is invalid
                                              if (value.length <= 1 && (phoneRegex.test(value) || value === '')) {
                                                HandleChanges(e);
                                              }
                                            }}

                                          />
                                          <p className="Error" style={{ marginLeft: "-5px" }}>
                                            {casualErro} </p>
                                        </div>
                                      </div>

                                    </div> */}

                                    {/* <div className="col-sm-3 mt-3" >
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Attendance Location
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{ position: "relative", top: "60px" }}
                                        onChange={(e) => {
                                          handleAttendanceLocationChange(e);

                                        }}
                                        isMulti
                                        options={PanIndiaPlace}
                                        labelledBy="Select"
                                        value={PanIndiaPlaceVal}
                                        isDisabled={data.pan_india}
                                        onInputChange={(val)=>{
                                          setSearchDebounance({
                                            ...SearchDebounance,
                                            Attendancelocation_se:val
                                          })
                                        }}
                                      />
                                      <div className="col-6 p-0">
                                        <label
                                          style={{
                                            marginRight: "10px",
                                            marginTop: "12px",
                                          }}
                                        >
                                          Pan India
                                        </label>
                                        <input
                                          type="checkbox"
                                          name="pan_india"
                                          onChange={(e) => {
                                            setPanIndia(!PanIndia);
                                            HandleChanges(e, PanIndia);


                                          }}
                                          checked={data.pan_india}
                                        />
                                      </div>
                                    </div> */}

                                    <div className="col-sm-3 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Site Code
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{
                                          position: "relative",
                                          top: "60px",
                                        }}
                                        onChange={(e) => {
                                          Handlethe_site_code(e);
                                          set_siteCode_err("");
                                        }}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={Branch_code_options}
                                        value={Branch_codeVal}
                                        onInputChange={(val) => {
                                          setSearchDebounance({
                                            ...SearchDebounance,
                                            Branch_code_se: val,
                                          });
                                        }}
                                        labelledBy="Select"
                                      />
                                      <p
                                        className="Error"
                                        style={{ marginLeft: "-5px" }}
                                      >
                                        {site_code_err}{" "}
                                      </p>
                                    </div>

                                    {/* {PanIndia ? "yes" :"no"}
                                   {data.pan_india ? "yes":""} */}

                                    {/* -----Muliti---select---Edits---State---------------- */}
                                    <div className="col-sm-3 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        State
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{
                                          position: "relative",
                                          top: "60px",
                                        }}
                                        // options={options}
                                        // onChange={handleChange}
                                        onChange={(e) => {
                                          handleState(e);
                                          setStateError("");
                                        }}
                                        isMulti
                                        // options={nameList}
                                        options={NameListState}
                                        value={SelectedStates}
                                        onInputChange={handleInputChange}
                                        labelledBy="Select"
                                        closeMenuOnSelect={false}
                                      />
                                      <p
                                        className="Error"
                                        style={{ marginLeft: "-5px" }}
                                      >
                                        {stateerror}
                                      </p>
                                    </div>

                                    <div className="col-sm-3 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Region
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{
                                          position: "relative",
                                          top: "60px",
                                        }}
                                        // options={options}
                                        // onChange={handleChange}
                                        onSelect={(e) => setRegionMUl(e)}
                                        onChange={(e) => {
                                          handleRegionSelected(e);
                                          setRegionError("");
                                        }}
                                        isMulti
                                        options={nameList2}
                                        value={SelectRegion}
                                        onInputChange={handleInputRegion}
                                        labelledBy="Select"
                                        closeMenuOnSelect={false}
                                        // placeholder={
                                        //   data.state_id != undefined &&
                                        //   data.state_id.length > 0
                                        //     ? "search"
                                        //     : "without selected state you can't select Region"
                                        // }
                                      />
                                      <p
                                        className="Error"
                                        style={{ marginLeft: "-5px" }}
                                      >
                                        {RegionError}
                                      </p>
                                    </div>
                                  </>

                                  {/* ----------------------_EDIT----------------------------- */}
                                  <>
                                    <div className="col-sm-3 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                      >
                                        Zone
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{
                                          position: "relative",
                                          top: "60px",
                                        }}
                                        // options={options}
                                        // onChange={handleChange}
                                        onSelect={(e) => setZoneMulEdi(e)}
                                        onChange={(e) => {
                                          handleZoneEdits(e);
                                          setZoneError("");
                                        }}
                                        isMulti
                                        options={nameList4}
                                        value={SelectedZone}
                                        onInputChange={handleInputZone}
                                        labelledBy="Select"
                                        closeMenuOnSelect={false}
                                        // placeholder={
                                        //   "without selected state and region  you can't select Zone"
                                        // }
                                      />
                                      <p
                                        className="Error"
                                        style={{ marginLeft: "-5px" }}
                                      >
                                        {ZoneError}
                                      </p>
                                    </div>
                                    <div className="col-sm-3 mt-3">
                                      <label
                                        for="validationCustom01"
                                        class="form-label"
                                        style={{ fontSize: "19px" }}
                                      >
                                        Organization
                                      </label>
                                      <Select
                                        className="Selects"
                                        styles={{
                                          position: "relative",
                                          top: "60px",
                                        }}
                                        onChange={(e) => {
                                          handlOrganizationList(e);
                                        }}
                                        options={Organization_options}
                                        labelledBy="Select"
                                        onInputChange={(val) => {
                                          setSearchDebounance({
                                            ...SearchDebounance,
                                            organization_search: val,
                                          });
                                        }}
                                        isMulti={true}
                                        isClearable={true}
                                        value={organizationSelectedList}
                                      />
                                      {console.log(
                                        data,
                                        "dkjaskjdjaskd",
                                        organizationSelectedList,
                                      )}
                                    </div>
                                  </>

                                  {/* <div className="col-sm-3 field-div ActiveStatusSub">
                                    <label htmlFor="isActiveToggle" className="toggleLabel">Unregister Access                                          <input
                                      type="checkbox"
                                      id="isActiveToggle"
                                      name="isActive"
                                      onChange={Handletoggle}


                                      className="toggleInput"
                                      checked={data.unregister_access}
                                    /></label>
                                    <div className="toggleSwitch">

                                      <span className="slider"></span>
                                    </div>
                                  </div> */}
                                  {/* {fieldaccess == 0 ? ( */}
                                  {optionsForAdim.length > 0 ? (
                                    <>
                                      <div
                                        className="col-sm-3"
                                        style={{ marginTop: "15px" }}
                                      >
                                        <label>Access List </label>
                                        <MultiSelect
                                          options={optionsForAdim}
                                          selectedValues={selectedOptions}
                                          onSelect={handleChange}
                                          onRemove={handleChange}
                                          labelledBy="Select"
                                          displayValue="name"
                                          placeholder=""
                                          className="custom-multiselect"
                                          singleSelect={false}
                                          disablePreSelectedValues={false}
                                          key={
                                            optionsForAdim.length +
                                            "-" +
                                            data.super_admin
                                          } // <---- FIX
                                          isObject={true}
                                          avoidHighlightFirstOption={true}
                                        />

                                        {/* <div className="col-6 mt-3">
                                          <label
                                            style={{ marginRight: "10px" }}
                                          >
                                            Super Admin
                                          </label>
                                          <input
                                            type="checkbox"
                                            name="super_admin"
                                            style={{cursor:"pointer"}}
                                            onChange={(e) => {
                                              setsupertrue(!superTrue);
                                              HandleChangesAdminRights(e, !data.super_admin);
                                            }}
                                            checked={data.super_admin}
                                          />
                                        </div> */}
                                      </div>
                                    </>
                                  ) : null}
                                  {/* ) : null} */}

                                  {/* ----------------------------Sign--------------------------------- */}
                                  {ManagerSign ? (
                                    <div
                                      className="col-6"
                                      style={{ padding: "10px" }}
                                    >
                                      {/* {
                                  state.UserRetrieve.userRetrireve
                                    .user_sign_image != null &&
                                  state.UserRetrieve.userRetrireve
                                    .user_sign_image != undefined 
                                    
                                    
                                    ? ( */}
                                      <>
                                        <label>
                                          Signature
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        {/* <div className="col-sm-4  ImageEditDisplay"> */}
                                        <div
                                          className="Image"
                                          style={{
                                            width: "200px",
                                            height: "200px",
                                            border: "1px solid #ddd",
                                          }}
                                        >
                                          {Img != null &&
                                          Img != "" &&
                                          Img != undefined ? (
                                            <img
                                              src={Img}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                              }}
                                            />
                                          ) : null}
                                        </div>
                                        <p
                                          style={{
                                            color: "red",
                                            width: "100%",
                                          }}
                                        >
                                          {state.signaturepad.setUserSignError}
                                        </p>
                                        <button
                                          className="Signatures ButtonCSS"
                                          onClick={(e) => {
                                            HandelPopup(e);
                                            Counting();
                                          }}
                                          style={{
                                            background: "#234492",
                                            color: "#ffff  !important",
                                          }}
                                        >
                                          Click here to sign
                                        </button>
                                      </>
                                      {/* // ) : 
                                  // null} */}
                                    </div>
                                  ) : null}
                                </>
                              ) : null}
                            </div>
                          </>
                        )}

                        <div
                          className="UserButtons"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{ background: "#234492b0" }}
                            onClick={(e) => handleClose(e)}
                          >
                            Cancel
                          </button>

                          <button
                            class="btn  ButtonCSS"
                            type="submit"
                            onClick={(e) => {
                              HandleClick(e);
                              HandleEdit(e);
                            }}
                            style={{ background: "#234492" }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default UserCreateForm;
